"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[41566],{

/***/ 78424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73060);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85780);





var useSidenavFlags = function(goalUID) {
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(isLoggedIn && goalUID ? "v1/user/me/menu_features_props/?goal_uid=".concat(goalUID) : null), data = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        sidenavFlags: data
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useSidenavFlags);


/***/ }),

/***/ 28197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54540);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);




var H7 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h6", {
    target: "e1z01og50",
    label: "H7"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.SEMIBOLD */ .F3.rX, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.H7 */ .F3.H7, ";line-height:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEADER_LINE_HEIGHT */ .F3.rm, ";margin:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_0B */ .t8.NE, ";color:", function(param) {
    var color = param.color;
    return color;
}, ";", function(param) {
    var lineClamp = param.lineClamp;
    return lineClamp ? _utils_styleHelper__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lineClampStyle */ .Z.lineClampStyle(lineClamp) : null;
});
/* harmony default export */ __webpack_exports__["Z"] = (H7);
H7.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    lineClamp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
};
H7.defaultProps = {
    color: "var(--color-text-primary)",
    lineClamp: null
};


/***/ }),

/***/ 42986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ri": function() { return /* binding */ preferenceDrawerTitle; },
/* harmony export */   "XC": function() { return /* binding */ notesPrefTypes; },
/* harmony export */   "d6": function() { return /* binding */ IndiaMap; },
/* harmony export */   "e_": function() { return /* binding */ PREFERENCES_STEP_INFO; },
/* harmony export */   "f$": function() { return /* binding */ addressFormErrorMap; },
/* harmony export */   "jo": function() { return /* binding */ headerScrollOffset; },
/* harmony export */   "n0": function() { return /* binding */ footerErrorMap; },
/* harmony export */   "pb": function() { return /* binding */ addressOnboardingStepsMap; },
/* harmony export */   "qH": function() { return /* binding */ printedNotesPageName; },
/* harmony export */   "sT": function() { return /* binding */ isPrintedNotesEnabled; },
/* harmony export */   "vp": function() { return /* binding */ confirmationTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var PREFERENCES_STEP_INFO = {
    DELIVERY_ADDRESS: 1,
    NOTES_PREFERENCES: 2,
    CONFIRM_DELIVERY_PREFERENCES: 3,
    PREPARING_PACKAGE: 4
};
var addressOnboardingStepsMap = {
    ADDRESS: 1,
    ADDRESS_NOTES: 2
};
var IndiaMap = {
    code: "IN",
    name: "India",
    flagIconUrl: "https://static.uacdn.net/thumbnail/country-flag-icons/in.png",
    phoneCode: "91"
};
var addressFormErrorMap = {
    ENTER_FULL_NAME: "Enter full name",
    ENTER_MOBILE_NUMBER: "Enter mobile number",
    ENTER_PINCODE: "Enter pincode",
    ENTER_ADDRESS: "Enter an address",
    ENTER_CITY: "Enter a city name",
    ENTER_STATE: "Enter a state name",
    INVALID_PINCODE: "Enter a valid pincode for India",
    INSUFFICIENT_DIGITS_IN_MOBILE_NUMBER: "Entered mobile number has insufficient digits",
    SPECIAL_CHARACTERS_NOT_ALLOWED: "Special characters are not allowed"
};
var footerErrorMap = {
    INVALID_DELIVERY_ADDRESS: "Add a valid delivery address to continue",
    INVALID_NOTES_PREFERENCES: "Select books preferences to continue",
    DEFAULT_ERROR: "Something went wrong. Please try again."
};
var notesPrefTypes = {
    PHYSICAL_NOTES_BOOKS: 1,
    PHYSICAL_NOTES_LANGUAGE: 2,
    STREAM: 3
};
var headerScrollOffset = 90;
var _obj;
var preferenceDrawerTitle = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, PREFERENCES_STEP_INFO.DELIVERY_ADDRESS, "Add delivery address"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, PREFERENCES_STEP_INFO.NOTES_PREFERENCES, "Select books preferences"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, PREFERENCES_STEP_INFO.CONFIRM_DELIVERY_PREFERENCES, "Confirm your delivery preferences"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, PREFERENCES_STEP_INFO.PREPARING_PACKAGE, "We\u2019re preparing your package"), _obj);
var _obj1;
var confirmationTitle = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, addressOnboardingStepsMap.ADDRESS, "Confirm your delivery address"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, addressOnboardingStepsMap.ADDRESS_NOTES, "Confirm your delivery preferences"), _obj1);
var isPrintedNotesEnabled = function() {
    var featureArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ele = featureArray.find(function(feature) {
        return feature.type === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .sideNavFlags.PRINTED_NOTES */ .eo.PRINTED_NOTES;
    });
    return !!ele;
};
var printedNotesPageName = "Unacademy books";


/***/ }),

/***/ 98716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ ADDRESS_COLLECTION_DO_IT_LATER_CLICKED; },
/* harmony export */   "H8": function() { return /* binding */ ADDRESS_COLLECTION_ADDRESS_FILL_CONTINUE_CLICKED; },
/* harmony export */   "S5": function() { return /* binding */ ADDRESS_COLLECTION_SET_UP_STARTED; },
/* harmony export */   "SJ": function() { return /* binding */ UNACADEMY_BOOKS_TRACK_BUTTON_CLICKED; },
/* harmony export */   "X5": function() { return /* binding */ UNACADEMY_BOOKS_TRACKING_FAILED; },
/* harmony export */   "_s": function() { return /* binding */ ADDRESS_COLLECTION_ADDRESS_CONFIRM_CLICKED; },
/* harmony export */   "eE": function() { return /* binding */ UNACADEMY_BOOKS_SECTION_CLICKED; },
/* harmony export */   "eM": function() { return /* binding */ ADDRESS_COLLECTION_ADDRESS_CONFIRMED_NEXT_CLICKED; },
/* harmony export */   "eS": function() { return /* binding */ ADDRESS_COLLECTION_ADDRESS_BACK_CLICKED; },
/* harmony export */   "iH": function() { return /* binding */ ADDRESS_COLLECTION_ADDRESS_FILL_CONTINUE_FAILED; },
/* harmony export */   "oA": function() { return /* binding */ ADDRESS_COLLECTION_UNACADEMY_BOOKS_ADD_PREFERENCES_STARTED; },
/* harmony export */   "qQ": function() { return /* binding */ ADDRESS_COLLECTION_PREFERENCE_NEXT_CLICKED; },
/* harmony export */   "tD": function() { return /* binding */ UNACADEMY_BOOKS_PAGE_VIEWED; }
/* harmony export */ });
var ADDRESS_COLLECTION_SET_UP_STARTED = "Address Collection - Set Up Started";
var ADDRESS_COLLECTION_ADDRESS_FILL_CONTINUE_CLICKED = "Address Collection - Address Fill Continue Clicked";
var ADDRESS_COLLECTION_ADDRESS_FILL_CONTINUE_FAILED = "Address Collection - Address Fill Continue Failed";
var ADDRESS_COLLECTION_PREFERENCE_NEXT_CLICKED = "Address Collection - Preference Next Clicked";
var ADDRESS_COLLECTION_ADDRESS_CONFIRM_CLICKED = "Address Collection - Address Confirm Clicked";
var ADDRESS_COLLECTION_ADDRESS_BACK_CLICKED = "Address Collection - Address Back Clicked";
var ADDRESS_COLLECTION_ADDRESS_CONFIRMED_NEXT_CLICKED = "Address Collection - Address Confirmed Next Clicked";
var ADDRESS_COLLECTION_DO_IT_LATER_CLICKED = "Address Collection - Do it Later Clicked";
var ADDRESS_COLLECTION_UNACADEMY_BOOKS_ADD_PREFERENCES_STARTED = "Address Collection - Unacademy Books Add Preferences Started";
var UNACADEMY_BOOKS_SECTION_CLICKED = "Unacademy Books - Section Clicked";
var UNACADEMY_BOOKS_PAGE_VIEWED = "Unacademy Books - Page Viewed";
var UNACADEMY_BOOKS_TRACK_BUTTON_CLICKED = "Unacademy Books - Track Button Clicked";
var UNACADEMY_BOOKS_TRACKING_FAILED = "Unacademy Notes - Tracking Failed";


/***/ }),

/***/ 2401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ SAVE_UNSAVE_CONTENT; },
/* harmony export */   "Dl": function() { return /* binding */ PLATFORM_HOME_PAGE; },
/* harmony export */   "Eu": function() { return /* binding */ UPCOMING_BATCHES; },
/* harmony export */   "Ht": function() { return /* binding */ eventLPSS; },
/* harmony export */   "LN": function() { return /* binding */ SAVE_SAVE_CONTENT; },
/* harmony export */   "Mi": function() { return /* binding */ ENROLLED_HOME_PAGE; },
/* harmony export */   "PG": function() { return /* binding */ VIEW_EDUCATOR; },
/* harmony export */   "T0": function() { return /* binding */ CLX_LESSON_VIEW_CLICKED; },
/* harmony export */   "Uu": function() { return /* binding */ SUBSCRIPTION_FEEDBACK_CARD_CLICKED; },
/* harmony export */   "Vb": function() { return /* binding */ BATCH_SCHEDULE_EXPAND_CLICKED; },
/* harmony export */   "Xp": function() { return /* binding */ NOTIFY_ME_CLICKED; },
/* harmony export */   "aE": function() { return /* binding */ SUBSCRIPTION_FEEDBACK_CARD_VIEWED; },
/* harmony export */   "cS": function() { return /* binding */ PLATFORM_PAGE_LAND; },
/* harmony export */   "dq": function() { return /* binding */ ACTIVITY_PAGE_SCROLLED; },
/* harmony export */   "fi": function() { return /* binding */ BATCH_GROUP_DETAIL; },
/* harmony export */   "j1": function() { return /* binding */ SEE_ALL_CLICKED; },
/* harmony export */   "k8": function() { return /* binding */ UPCOMING_SECTION_VIEWED; },
/* harmony export */   "mX": function() { return /* binding */ PLATFORM_BATCH_GROUP; },
/* harmony export */   "pR": function() { return /* binding */ LESSON_DOWNLOAD_PDF; },
/* harmony export */   "sH": function() { return /* binding */ SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED; },
/* harmony export */   "wF": function() { return /* binding */ BATCH_TAB_CLICKED; },
/* harmony export */   "wz": function() { return /* binding */ PLATFORM_SUBSCRIPTION_RATING; },
/* harmony export */   "zI": function() { return /* binding */ NOTIFY_ME_REMOVED; }
/* harmony export */ });
/* unused harmony exports BATCH_SECTION_TYPE_VIEW, BATCH_EXPAND_CLICKED */
// events constants
var NOTIFY_ME_CLICKED = "Notify - Notify Me Clicked";
var NOTIFY_ME_REMOVED = "Notify - Notify Me Removed";
var CLX_LESSON_VIEW_CLICKED = "CLX - Lesson Clicked";
var eventLPSS = {
    BATCH_AND_TRIAL_CLASS_LIST: "Section Batch Details & Demo class list",
    SCHEDULE: "Section Schedule",
    LESSONS: "Section Lesson",
    ABOUT_AND_EDUCATORS: "Section About and Educators",
    FAQ_AND_TTUN_CTA: "Section FAQ and TTUN",
    EDUCATORS: "Section Educators",
    BATCH_AND_OVERVIEW: "Section Batch Details & Overview"
};
var PLATFORM_PAGE_LAND = "Platform - Platform Page Land";
var UPCOMING_SECTION_VIEWED = "Batch Selection - Batch List Viewed";
var PLATFORM_HOME_PAGE = "Batch Group Home page";
var SEE_ALL_CLICKED = "See All Clicked";
var ENROLLED_HOME_PAGE = "Enrolled - Home Page";
var ACTIVITY_PAGE_SCROLLED = "Activity - Page Scrolled";
var BATCH_SECTION_TYPE_VIEW = "Batch Selection - Select Batch Type Viewed";
var BATCH_TAB_CLICKED = "Batch - Batch Tab Clicked";
var SAVE_SAVE_CONTENT = "Save - Save Content";
var SAVE_UNSAVE_CONTENT = "Save - Unsave Content";
var LESSON_DOWNLOAD_PDF = "Lesson PDF Downloaded";
var VIEW_EDUCATOR = "Educator Profile Clicked";
var BATCH_EXPAND_CLICKED = "Batch Expand Clicked";
var BATCH_SCHEDULE_EXPAND_CLICKED = "Batch - Batch Expand Clicked";
var UPCOMING_BATCHES = "Batch Group Upcoming List";
// feedback events
var SUBSCRIPTION_FEEDBACK_CARD_CLICKED = "Subscription Feedback Card - Clicked";
var SUBSCRIPTION_FEEDBACK_CARD_SUBMITTED = "Subscription Feedback Card - Submitted";
var SUBSCRIPTION_FEEDBACK_CARD_VIEWED = "Subscription Feedback Card - Viewed";
var BATCH_GROUP_DETAIL = "Batch Group Detail";
var PLATFORM_SUBSCRIPTION_RATING = "Platform Subscription Rating";
var PLATFORM_BATCH_GROUP = "Platform Batch Group";


/***/ }),

/***/ 10736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ BATCH_GROUP_TYPE; },
/* harmony export */   "Ac": function() { return /* binding */ BatchType; },
/* harmony export */   "Bb": function() { return /* binding */ cardCtaConfig; },
/* harmony export */   "C0": function() { return /* binding */ PLAY_ICON_DARK; },
/* harmony export */   "C5": function() { return /* binding */ MAXIMUM_CLASSES_TO_SHOW_WITHOUT_SEE_ALL; },
/* harmony export */   "Eu": function() { return /* binding */ BG_OVERVIEW_TAB_ORDERING; },
/* harmony export */   "GZ": function() { return /* binding */ batchGroupNave; },
/* harmony export */   "HT": function() { return /* binding */ filterType; },
/* harmony export */   "Iw": function() { return /* binding */ cardType; },
/* harmony export */   "Jg": function() { return /* binding */ tabLabel; },
/* harmony export */   "Lv": function() { return /* binding */ DEFAULT_QUERY_TYPE; },
/* harmony export */   "MP": function() { return /* binding */ defaultTabsConfig; },
/* harmony export */   "Pk": function() { return /* binding */ boxShadowColorPercent; },
/* harmony export */   "Tx": function() { return /* binding */ DEFAULT_ITEM_LENGTH_FOR_SEE_ALL; },
/* harmony export */   "Ub": function() { return /* binding */ STATIC_BLOCK_SECTIONS; },
/* harmony export */   "Vo": function() { return /* binding */ BATCH_GROUP_TYPE_CONFIG; },
/* harmony export */   "Yv": function() { return /* binding */ LANGUAGE_COUNT_FOR_CARD; },
/* harmony export */   "aG": function() { return /* binding */ SPACE_WITH_DOT; },
/* harmony export */   "bx": function() { return /* binding */ Sections; },
/* harmony export */   "gy": function() { return /* binding */ CLASS_STATE; },
/* harmony export */   "jz": function() { return /* binding */ MAXIMUM_BATCHES_TO_SHOW_WITHOUT_SEE_ALL; },
/* harmony export */   "lv": function() { return /* binding */ ENTITY_SUB_TYPE; },
/* harmony export */   "p7": function() { return /* binding */ cardWidth; },
/* harmony export */   "rP": function() { return /* binding */ batchGroupType; },
/* harmony export */   "tB": function() { return /* binding */ ITEM_TO_SHOW_IN_M_WEB; },
/* harmony export */   "x2": function() { return /* binding */ PLAY_ICON; }
/* harmony export */ });
/* unused harmony exports MAXIMUM_LANGUAGES_TO_SHOW, BATCH_ACCESS_ENDED */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2080);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2401);



var notificationsType = {
    UPCOMING_BATCHES: 1,
    ONGOING_BATCHES: 2
};
// number of static block sections on batch group details page
var STATIC_BLOCK_SECTIONS = 3;
var DEFAULT_ITEM_LENGTH_FOR_SEE_ALL = 3;
var ITEM_TO_SHOW_IN_M_WEB = 1;
var MAXIMUM_BATCHES_TO_SHOW_WITHOUT_SEE_ALL = 3;
var MAXIMUM_CLASSES_TO_SHOW_WITHOUT_SEE_ALL = 4;
var Sections = {
    DEMO_CLASSES: "DEMO_CLASSES",
    BATCH_SCHEDULE: "BATCH_SCHEDULE",
    EDUCATORS: "EDUCATORS",
    FAQS: "FAQS",
    ABOUT: "ABOUT",
    LESSONS: "LESSONS"
};
var tabLabel = {
    DEMO_CLASSES: "Demo Classes",
    BATCH_SCHEDULE: "Schedule",
    EDUCATORS: "Educators",
    FAQS: "FAQs",
    ABOUT: "Overview",
    LESSONS: "Lessons"
};
var _obj;
var defaultTabsConfig = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, Sections.BATCH_SCHEDULE, {
    label: tabLabel.BATCH_SCHEDULE,
    key: Sections.BATCH_SCHEDULE,
    id: 1,
    value: 1
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, Sections.LESSONS, {
    label: tabLabel.LESSONS,
    key: Sections.LESSONS,
    id: 5,
    value: 5
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, Sections.EDUCATORS, {
    label: tabLabel.EDUCATORS,
    key: Sections.EDUCATORS,
    id: 3,
    value: 3
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, Sections.ABOUT, {
    label: tabLabel.ABOUT,
    key: Sections.ABOUT,
    id: 2,
    value: 2
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, Sections.FAQS, {
    label: tabLabel.FAQS,
    key: Sections.FAQS,
    id: 4,
    value: 4
}), _obj);
var batchGroupNave = {
    home: "batch-group/home",
    browse: "batch-group/browse"
};
var filterType = {
    0: "Live&Recorded",
    2: "Recorded",
    10: "Live"
};
var DEFAULT_QUERY_TYPE = 0;
var MAXIMUM_LANGUAGES_TO_SHOW = 3;
var batchGroupType = {
    LIVE: 1,
    RECORDED: 2,
    LIVE_AND_RECORDED: 3
};
/* harmony default export */ __webpack_exports__["ZP"] = (notificationsType);
var BG_OVERVIEW_TAB_ORDERING = "bg_overview_tab_ordering";
var SPACE_WITH_DOT = "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_2SPACES */ .t8.yP, "\u2022").concat(_styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_2SPACES */ .t8.yP);
var cardCtaConfig = {
    1: {
        buttonColor: "var(--color-red-border-focus)",
        textColor: "var(--color-i-red)"
    },
    2: {
        textColor: "var(--color-text-primary)",
        buttonColor: "var(--color-base-light-0)"
    },
    3: {
        textColor: "var(--color-text-secondary)",
        buttonColor: "var(--color-base-light-0)"
    }
};
var cardWidth = {
    SMALL: {
        web: "272px",
        mobile: "100%"
    },
    MEDIUM: {
        web: "340px",
        mobile: "100%"
    },
    LARGE: {
        web: "365px",
        mobile: "100%"
    }
};
var BATCH_ACCESS_ENDED = 4;
var cardType = {
    SMALL: "SMALL",
    MEDIUM: "MEDIUM",
    LARGE: "LARGE"
};
var LANGUAGE_COUNT_FOR_CARD = 3;
var ENTITY_SUB_TYPE = {
    1: "Live",
    2: "Recorded",
    3: "Live&Recorded"
};
var CLASS_STATE = {
    LIVE_STATE: 0,
    UPCOMING_STATE: 1,
    COMPLETELY_WATCHED_STATE: 2,
    CONTINUE_WATCH_STATE: 3,
    NOT_WATCHED_STATE: 4,
    RESCHEDULED_STATE: 5,
    CANCELLED_STATE: 6,
    ACCESS_ENDED_STATE: 7
};
var boxShadowColorPercent = {
    0: "rgba(235, 87, 87, 0.4)",
    70: "rgba(235,87,87, 0)"
};
var BatchType = {
    liveBatch: 1,
    recordedBatch: 2,
    hybridBatch: 3
};
var BATCH_GROUP_TYPE_CONFIG = {
    live_batchgroups: {
        eventName: _events__WEBPACK_IMPORTED_MODULE_1__/* .UPCOMING_SECTION_VIEWED */ .k8,
        lpss: "Platform Home",
        lpssForBatchCard: "Platform Home - Batches",
        batchType: "Live&Recorded"
    },
    recorded_batchgroups: {
        eventName: _events__WEBPACK_IMPORTED_MODULE_1__/* .UPCOMING_SECTION_VIEWED */ .k8,
        lpss: "Platform Home",
        lpssForBatchCard: "Platform Home - Batches",
        batchType: "Recorded"
    },
    default: {
        eventName: _events__WEBPACK_IMPORTED_MODULE_1__/* .UPCOMING_SECTION_VIEWED */ .k8,
        lpss: "Platform Home",
        lpssForBatchCard: "Platform Home - Batches",
        batchType: "Live"
    }
};
var BATCH_GROUP_TYPE = {
    LIVE: "live_batchgroups",
    RECORDED: "recorded_batchgroups"
};
var PLAY_ICON_DARK = "batch-group/plat-icon-dark.svg";
var PLAY_ICON = "batch-group/play-icon.svg";


/***/ }),

/***/ 29673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ blueDotFeature; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var blueDotFeature = {
    DOUBTS: 4
};


/***/ }),

/***/ 80408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bb": function() { return /* binding */ NOTES_TEXT_SIZE_CHANGED; },
/* harmony export */   "CN": function() { return /* binding */ NOTES_TEXT_SETTINGS_HOVERED; },
/* harmony export */   "DF": function() { return /* binding */ getNotesEndpoint; },
/* harmony export */   "G0": function() { return /* binding */ getConceptListEndpoint; },
/* harmony export */   "H8": function() { return /* binding */ NOTES_IMAGE_VIEWED; },
/* harmony export */   "II": function() { return /* binding */ NOTES_CONCEPT_SELECTED; },
/* harmony export */   "Mo": function() { return /* binding */ NOTES_SEARCH_CLICKED; },
/* harmony export */   "Mt": function() { return /* binding */ NOTES_SUB_ITEM_SELECTED; },
/* harmony export */   "Np": function() { return /* binding */ EPUB_NOTES; },
/* harmony export */   "On": function() { return /* binding */ findFirstEnabledConcept; },
/* harmony export */   "SH": function() { return /* binding */ NOTES_THEME_CHANGED; },
/* harmony export */   "ag": function() { return /* binding */ NOTES_HIDE_NAVIGATION_CLICKED; },
/* harmony export */   "b0": function() { return /* binding */ NOTES_TOPIC_DROPDOWN_SELECTED; },
/* harmony export */   "eR": function() { return /* binding */ NOTES_TOPIC_SELECTED; },
/* harmony export */   "mU": function() { return /* binding */ NOTES_SECTION_CLICKED; },
/* harmony export */   "n5": function() { return /* binding */ DEFAULT_FONT_SIZE; },
/* harmony export */   "np": function() { return /* binding */ themes; },
/* harmony export */   "ob": function() { return /* binding */ NOTES_PAGE_NAVIGATION_CLICKED; },
/* harmony export */   "oi": function() { return /* binding */ NOTES_GET_STARTED_CLICKED; },
/* harmony export */   "ol": function() { return /* binding */ NOTES_VIEWED; },
/* harmony export */   "tJ": function() { return /* binding */ getTopicListEndpoint; },
/* harmony export */   "vE": function() { return /* binding */ NOTES_IMAGE_CLICKED; }
/* harmony export */ });
var findFirstEnabledConcept = function() {
    var concepts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return concepts.find(function(concept) {
        return concept.isEpubAvailable || concept.isNotesAvailable;
    });
};
var themes = {
    LIGHT: "LIGHT",
    DARK: "DARK"
};
var DEFAULT_FONT_SIZE = 100;
// event constants
var NOTES_SECTION_CLICKED = "Notes - Notes Section Clicked";
var NOTES_TOPIC_SELECTED = "Notes - Topic Selected";
var NOTES_CONCEPT_SELECTED = "Notes - Concept Selected";
var EPUB_NOTES = "Epub Notes Page";
var NOTES_TOPIC_DROPDOWN_SELECTED = "Notes - Topic Dropdown Selected";
var NOTES_SEARCH_CLICKED = "Notes - Search Clicked";
var NOTES_IMAGE_CLICKED = "Notes - Image Clicked";
var NOTES_IMAGE_VIEWED = "Notes - Image Viewed";
var NOTES_HIDE_NAVIGATION_CLICKED = "Notes - Hide Navigation Clicked";
var NOTES_TEXT_SETTINGS_HOVERED = "Notes - Text Settings Hovered";
var NOTES_THEME_CHANGED = "Notes - Theme Changed";
var NOTES_TEXT_SIZE_CHANGED = "Notes - Text Size Changed";
var NOTES_GET_STARTED_CLICKED = "Notes - Get Started Clicked";
var NOTES_PAGE_NAVIGATION_CLICKED = "Notes - Page Navigation Clicked";
var NOTES_SUB_ITEM_SELECTED = "Notes - Sub item Selected";
var NOTES_VIEWED = "Notes - Viewed";
var getTopicListEndpoint = function(goalUID) {
    return "v1/topology/child/list/?goal_uid=".concat(goalUID, "&hide_empty_notes_tg=true&notes_type=epub");
};
var getConceptListEndpoint = function(topicUID) {
    return "v1/topology/child/notes/?topology_uid=".concat(topicUID, "&notes_type=epub");
};
var getNotesEndpoint = function(conceptUID) {
    var notesType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "epub";
    return "v1/topology/notes/?topology_uid=".concat(conceptUID, "&feed=notes_feed&notes_type=").concat(notesType);
};


/***/ }),

/***/ 34085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var _base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28066);
/* harmony import */ var _base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15509);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44545);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87936);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52405);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43605);




/* eslint-disable react/jsx-props-no-spreading */ 






var Login = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(52420), __webpack_require__.e(96523), __webpack_require__.e(9720), __webpack_require__.e(46571), __webpack_require__.e(94336), __webpack_require__.e(84079), __webpack_require__.e(98789)]).then(__webpack_require__.bind(__webpack_require__, 84079));
});
var LoginDialogBox = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
    return __webpack_require__.e(/* import() */ 13088).then(__webpack_require__.bind(__webpack_require__, 13088));
});
var LoginComponent = function(param) {
    var _loginProps = param.loginProps, loginProps = _loginProps === void 0 ? {} : _loginProps, _drawerProps = param.drawerProps, drawerProps = _drawerProps === void 0 ? {} : _drawerProps;
    var IsNewLoginModal = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_6__/* .getIsNewLoginModal */ .zf);
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({});
    var onClose = drawerProps.onClose, drawerState = drawerProps.drawerState, restDrawerProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(drawerProps, [
        "onClose",
        "drawerState"
    ]);
    var handleClose = function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_3__/* .segment.track */ .EX.track(_constants__WEBPACK_IMPORTED_MODULE_5__/* .LOGIN_SIDE_CURTAIN_DISMISSED */ .z0, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, goalSegmentData));
        onClose();
    };
    if (!drawerState) return null;
    if (IsNewLoginModal) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(LoginDialogBox, {
        isOpen: drawerState,
        onClose: onClose,
        loginProps: loginProps
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_1__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        login: true,
        drawerState: drawerState,
        onClose: handleClose
    }, restDrawerProps), {
        children: drawerState && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Login, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, loginProps))
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginComponent);


/***/ }),

/***/ 80560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76226);
/* harmony import */ var _api_fetchers_experiments__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97163);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18113);
/* harmony import */ var _utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32415);
/* harmony import */ var _cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43605);
/* harmony import */ var _stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98964);
/* harmony import */ var _stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44545);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);









// Test1 - with phone number and OTP field on the same page
// Test2 - phone number on one page and OTP on other page
// Control - side curtain
var useLoginModalExperiment = function() {
    var setIsNewLoginModal = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsNewLoginModal */ .qN);
    var setIsLoginModalExperiment = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsLoginModalExperiment */ .lf);
    var setIsLoginModalVariation = (0,_stores_login_loginStore__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_stores_selectors_login__WEBPACK_IMPORTED_MODULE_8__/* .getSetIsLoginModalVariation */ .Rw);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var route = router.route;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (_cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__/* .routesToBeInCluded.includes */ .tP.includes(route)) {
            (0,_utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)();
            var deviceID = _utils_cookies__WEBPACK_IMPORTED_MODULE_3__/* ["default"].readCookie */ .ZP.readCookie(_utils_session_validateAndSetSessionId__WEBPACK_IMPORTED_MODULE_4__/* .DEVICE_ID_COOKIE_NAME */ .CR);
            (0,_api_fetchers_experiments__WEBPACK_IMPORTED_MODULE_2__/* .fetchABExperimentData */ .d)(_cont_Login_constants__WEBPACK_IMPORTED_MODULE_5__/* .LOGIN_MODAL_EXPERIMENT */ .OC, _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abProxyJWT */ .q_, deviceID).then(function(res) {
                if (res === null || res === void 0 ? void 0 : res.variation) {
                    setIsNewLoginModal(res.variation !== _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                    setIsLoginModalExperiment(res.variation !== _utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                    setIsLoginModalVariation(res.variation);
                } else {
                    setIsNewLoginModal(false);
                    setIsLoginModalExperiment(false);
                    setIsLoginModalVariation(_utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
                }
            });
        } else {
            setIsNewLoginModal(false);
            setIsLoginModalExperiment(false);
            setIsLoginModalVariation(_utils_abHelper__WEBPACK_IMPORTED_MODULE_1__/* .abVariations.CONTROL */ .WS.CONTROL);
        }
    }, [
        route,
        setIsNewLoginModal,
        setIsLoginModalExperiment,
        setIsLoginModalVariation
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLoginModalExperiment);


/***/ }),

/***/ 59479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useTimeout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11083);


var useMounted = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,_useTimeout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        setIsMounted(true);
    }, 0);
    return isMounted;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMounted);


/***/ }),

/***/ 51320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var AppContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1m9w4060",
    label: "AppContainer"
})("width:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.APP_CONTAINER_WIDTH */ .t8.MS, ";margin:auto;display:grid;grid-template-columns:repeat(24,1fr);grid-column-gap:16px;grid-row-gap:16px;min-height:", function(param) {
    var $isFooterHidden = param.$isFooterHidden;
    return " calc(\n    100vh -\n      ".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_HEADER */ .t8.bu + _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_HEADER_MARGIN */ .t8.Cj + ($isFooterHidden ? 0 : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_FOOTER */ .t8.SV + _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_FOOTER_MARGIN */ .t8.lK + 12), "px\n  )");
}, ";@media (max-width:70.95em){width:", function(param) {
    var $tabletWidth = param.$tabletWidth;
    return $tabletWidth || "1136px";
}, ";grid-template-columns:repeat(24,1fr);}");
/* harmony default export */ __webpack_exports__["Z"] = (AppContainer);


/***/ }),

/***/ 17359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e4w0nax0",
    label: "Container"
})("min-height:100vh;background-color:", function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "var(--color-base-0)";
}, ";min-width:100%;position:relative;");
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 79707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var Content = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eb5yt830",
    label: "Content"
})("display:grid;grid-column:1 / 25;grid-template-columns:repeat(24,32px);grid-column-gap:16px;grid-auto-rows:max-content;grid-row-gap:16px;@media (max-width:70.95em){grid-template-columns:repeat(24,1fr);grid-column-gap:8px;}");
/* harmony default export */ __webpack_exports__["Z"] = (Content);


/***/ }),

/***/ 69449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2080);



var Icon = function(param) {
    var width = param.width, height = param.height, color = param.color, onClick = param.onClick, className = param.className, path = param.path, path2 = param.path2, size = param.size, children = param.children, viewBox = param.viewBox, pathFillRule = param.pathFillRule, pathClipRule = param.pathClipRule, gpathFillRule = param.gpathFillRule, gpathClipRule = param.gpathClipRule, pathFillRule2 = param.pathFillRule2, pathClipRule2 = param.pathClipRule2, stroke = param.stroke, strokeWidth = param.strokeWidth, strokeLinecap = param.strokeLinecap, strokeLinejoin = param.strokeLinejoin, opacity = param.opacity, gpath = param.gpath, cx = param.cx, cy = param.cy, r = param.r, rectx = param.rectx, recty = param.recty, rectWidth = param.rectWidth, rectHeight = param.rectHeight, rx = param.rx;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", {
        width: size || width,
        height: size || height,
        viewBox: viewBox,
        onClick: onClick,
        className: className,
        children: [
            rectx || recty || rectWidth || rectHeight ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                opacity: "0.3",
                x: rectx,
                y: recty,
                width: rectWidth,
                height: rectHeight,
                rx: rx,
                fill: color
            }) : null,
            cx || cy || r ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                opacity: "0.3",
                cx: cx,
                cy: cy,
                r: r,
                fill: color
            }) : null,
            opacity && gpath ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("g", {
                opacity: opacity,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                    d: gpath,
                    fill: color,
                    fillRule: gpathFillRule,
                    clipRule: gpathClipRule,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeLinecap: strokeLinecap,
                    strokeLinejoin: strokeLinejoin,
                    className: className
                })
            }) : null,
            path && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: path,
                fill: color,
                fillRule: pathFillRule,
                clipRule: pathClipRule,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin,
                className: className
            }),
            path2 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: path2,
                fill: color,
                fillRule: pathFillRule2,
                clipRule: pathClipRule2,
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: strokeLinecap,
                strokeLinejoin: strokeLinejoin,
                className: className
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);
Icon.propTypes = {
    path: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
    viewBox: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    pathFillRule: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    pathClipRule: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    stroke: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    strokeWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    strokeLinecap: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    strokeLinejoin: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    gpathFillRule: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    gpathClipRule: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Icon.defaultProps = {
    path: null,
    color: "var(--color-base-fill)",
    size: _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_3B */ .t8.N,
    className: "",
    width: _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_3B */ .t8.N,
    height: _styles_index__WEBPACK_IMPORTED_MODULE_0__/* .Spacings.SPACING_3B */ .t8.N,
    onClick: function() {},
    children: null,
    viewBox: "0 0 80 80",
    pathFillRule: "unset",
    pathClipRule: "unset",
    gpathFillRule: "unset",
    gpathClipRule: "unset",
    stroke: null,
    strokeWidth: null,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
};


/***/ }),

/***/ 41566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/constants.js
var constants = __webpack_require__(47426);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/api/fetchers/ttu/index.js
var ttu = __webpack_require__(57001);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/selectors/ttuSelectors.js
var ttuSelectors = __webpack_require__(29870);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/stores/toggleables.js
var toggleables = __webpack_require__(85690);
// EXTERNAL MODULE: ./src/constants/toggleables.js
var constants_toggleables = __webpack_require__(28119);
// EXTERNAL MODULE: ./src/stores/selectors/playerReferralDialog.js
var playerReferralDialog = __webpack_require__(76205);
// EXTERNAL MODULE: ./src/stores/playerReferralDialog.js
var stores_playerReferralDialog = __webpack_require__(41721);
// EXTERNAL MODULE: ./src/stores/ttu.js
var stores_ttu = __webpack_require__(94835);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/hooks/topology/useSelectedGoal.js
var useSelectedGoal = __webpack_require__(96487);
// EXTERNAL MODULE: ./src/components/Container/Login/utils/hooks/useLoginModalExperiment.js
var useLoginModalExperiment = __webpack_require__(80560);
// EXTERNAL MODULE: ./src/components/Container/Login/LoginComponent.jsx
var LoginComponent = __webpack_require__(34085);
// EXTERNAL MODULE: ./src/layout/Header/Header.jsx + 1 modules
var Header = __webpack_require__(32078);
// EXTERNAL MODULE: ./src/layout/Components/Content.jsx
var Content = __webpack_require__(79707);
// EXTERNAL MODULE: ./src/layout/Components/AppContainer.jsx
var AppContainer = __webpack_require__(51320);
// EXTERNAL MODULE: ./src/layout/Footer/BaseFooter.jsx + 8 modules
var BaseFooter = __webpack_require__(95965);
// EXTERNAL MODULE: ./src/layout/Components/Container.jsx
var Container = __webpack_require__(17359);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/hooks/usePlatformInfo.js
var usePlatformInfo = __webpack_require__(79592);
// EXTERNAL MODULE: ./src/api/hooks/topology/useTopology.js
var useTopology = __webpack_require__(71609);
;// CONCATENATED MODULE: ./src/api/selectors/topology.js
var getIsCatalogueFeatureAvailable = function(topology) {
    return topology.isCatalogueFeatureAvailable || false;
};
var getIsPlusAvailable = function(topology) {
    return topology.isPlusAvailable || false;
};
var getTopologySlug = function(topology) {
    return topology.goalSlug || topology.slug || "-";
};
var getIsSyllabusV1Enabled = function(topology) {
    return topology.isSyllabusV1Enabled || false;
};
var getIsNoTestGoal = function(topology) {
    return topology.isNoTestGoal;
};
var getIsPracticeAvailable = function(topology) {
    return topology.isPracticeAvailable || false;
};
var getIsRecordedGoal = function(topology) {
    return topology.isRecordedGoal || false;
};

// EXTERNAL MODULE: ./src/api/selectors/subscription.js
var subscription = __webpack_require__(58063);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var selectors_constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/components/Container/EpubNotes/utils/index.ts
var utils = __webpack_require__(80408);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/stores/selectors/sidenav.js
var selectors_sidenav = __webpack_require__(66478);
// EXTERNAL MODULE: ./src/utils/localStorage.js
var utils_localStorage = __webpack_require__(77090);
// EXTERNAL MODULE: ./src/components/Container/AddressCollection/events.js
var events = __webpack_require__(98716);
// EXTERNAL MODULE: ./src/layout/NavBar/PlusNavBar/plusNavBarItems.js
var plusNavBarItems = __webpack_require__(2990);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/api/hooks/useSidenavFlags.js
var useSidenavFlags = __webpack_require__(78424);
// EXTERNAL MODULE: ./src/constants/index.js
var src_constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/utils/algos.js
var algos = __webpack_require__(53373);
// EXTERNAL MODULE: ./src/layout/NavBar/PlusNavBar/NavIcon.jsx
var NavIcon = __webpack_require__(69449);
;// CONCATENATED MODULE: ./src/components/Icons/notes/NavNotes.jsx




var NavNotes = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 20 20",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        opacity: "0.3",
        gpath: "M5.5 4C5.5 2.89543 4.60457 2 3.5 2V2C2.39543 2 1.5 2.89543 1.5 4V16C1.5 17.1046 2.39543 18 3.5 18H5.5V4Z",
        path: " M5.5 4C5.5 2.89543 6.39543 2 7.5 2H16.5C17.6046 2 18.5 2.89543 18.5 4V16C18.5 17.1046 17.6046 18 16.5 18H5.5V4Z M16 7.4C16 7.73137 15.7314 8 15.4 8H8.6C8.26863 8 8 7.73137 8 7.4V7.4C8 7.06863 8.26863 6.8 8.6 6.8H15.4C15.7314 6.8 16 7.06863 16 7.4V7.4Z M16 9.9C16 10.2314 15.7314 10.5 15.4 10.5H8.6C8.26863 10.5 8 10.2314 8 9.9V9.9C8 9.56863 8.26863 9.3 8.6 9.3H15.4C15.7314 9.3 16 9.56863 16 9.9V9.9Z M10.5 12.4C10.5 12.7314 10.2314 13 9.9 13H8.7C8.36863 13 8.1 12.7314 8.1 12.4V12.4C8.1 12.0686 8.36863 11.8 8.7 11.8H9.9C10.2314 11.8 10.5 12.0686 10.5 12.4V12.4Z"
    }));
};
/* harmony default export */ var notes_NavNotes = (NavNotes);

;// CONCATENATED MODULE: ./src/components/Container/AddressCollection/PrintedNotes/PrintedNotesIcon.jsx




var PrintedNotesIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 20 20",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        opacity: "0.3",
        gpath: "M3 17.0381C3 17.5904 3.44772 18.0381 4 18.0381H15.5V2.03809H4C3.44772 2.03809 3 2.4858 3 3.03809V17.0381Z",
        path: "M16 2H5.5V18H16C16.5523 18 17 17.5224 17 16.9333V3.06667C17 2.47756 16.5523 2 16 2ZM8 12.6667C7.72386 12.6667 7.5 12.9054 7.5 13.2V15.3333C7.5 15.6279 7.72386 15.8667 8 15.8667H14.5C14.7761 15.8667 15 15.6279 15 15.3333V13.2C15 12.9054 14.7761 12.6667 14.5 12.6667H8Z"
    }));
};
/* harmony default export */ var PrintedNotes_PrintedNotesIcon = (PrintedNotesIcon);

// EXTERNAL MODULE: ./src/components/Container/AddressCollection/constants.js
var AddressCollection_constants = __webpack_require__(42986);
// EXTERNAL MODULE: ./src/components/Container/Doubts20/constants.js
var Doubts20_constants = __webpack_require__(29673);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
;// CONCATENATED MODULE: ./src/api/hooks/planner/useBottomSheetDetails.js





var useBottomSheetDetails = function(goalUID) {
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var key = isLoggedIn && goalUID ? "v1/planner/bottom_sheet/details/?goal_uid=".concat(goalUID) : null;
    var _ref = (0,useFetch/* default */.Z)(key, {
        useCamelCase: false
    }), _data = _ref.data, data = _data === void 0 ? {} : _data, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data"
    ]);
    return (0,_object_spread/* default */.Z)({
        data: data
    }, rest);
};
/* harmony default export */ var planner_useBottomSheetDetails = (useBottomSheetDetails);

// EXTERNAL MODULE: ./src/hooks/useMounted.js
var useMounted = __webpack_require__(59479);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/CommonComps.jsx



var StyH7 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "e107ise40",
    label: "StyH7"
})("margin-top:", function(param) {
    var $isLite = param.$isLite;
    return $isLite ? 0 : "".concat(styleConstants/* Spacings.SPACING_8B */.t8.B3);
}, ";padding:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, " ", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-secondary);font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, ";");
var NumberDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e107ise41",
    label: "NumberDiv"
})("background-color:var(--color-divider);border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";padding:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, " ", styleConstants/* Spacings.SPACING_6 */.t8.A1, ";font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, " !important;font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, " !important;line-height:", styleConstants/* Fonts.PARA_LINE_HEIGHT */.F3.MA, " !important;margin-left:auto;&:hover{background-color:var(--color-divider) !important;}");

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/commonUtils.js

var getGoalAs = function(goalUID, goalSlug) {
    return "/goal/".concat(goalSlug, "/").concat(goalUID);
};
var goalHref = "/goal/[goalSlug]/[goalUID]";
var ICON_IMG_PATH = {
    normal: {
        PRACTICE: "plusNavBar/practice.svg",
        SAVED: "plusNavBar/saved.svg",
        PLANNER: "plusNavBar/planner.svg",
        HOME: "plusNavBar/home.svg",
        BROWSE: "plusNavBar/browse.svg",
        SYLLABUS: "plusNavBar/syllabus.svg",
        TEST_SERIES: "plusNavBar/testSeries.svg",
        DOUBTS_AND_SOLUTIONS: "plusNavBar/doubtsAndSolutions2.svg",
        ENROLLMENTS: "plusNavBar/enrollments.svg",
        FREE_CLASSES_AND_TESTS: "plusNavBar/freeLiveClasses.svg",
        OTER_COURSES: "plusNavBar/otherCourses.svg"
    },
    hover: {
        PRACTICE: "plusNavBar/hovPractice.svg",
        SAVED: "plusNavBar/hovSaved.svg",
        PLANNER: "plusNavBar/hovPlanner.svg",
        HOME: "plusNavBar/hovHome.svg",
        BROWSE: "plusNavBar/hovBrowse.svg",
        SYLLABUS: "plusNavBar/hovSyllabus.svg",
        TEST_SERIES: "plusNavBar/hovTestSeries.svg",
        DOUBTS_AND_SOLUTIONS: "plusNavBar/hovDoubtsAndSolutions2.svg",
        ENROLLMENTS: "plusNavBar/hovEnrollments.svg",
        FREE_CLASSES_AND_TESTS: "plusNavBar/hovFreeLiveClasses.svg",
        OTER_COURSES: "plusNavBar/hovOtherCourses.svg"
    }
};
var TEST_REVAMP_STORAGE_KEY = "hide_blue_dot_for_test_revamp";
var setStorageKeyForTestRevamp = function() {
    if ((0,utils_localStorage/* localStorageAvailable */.V)()) {
        localStorage.setItem(TEST_REVAMP_STORAGE_KEY, true);
    }
};
var getIsBlueDotshownForTestRevamp = function() {
    var isTestRevampGoal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (isTestRevampGoal && (0,utils_localStorage/* localStorageAvailable */.V)()) {
        var key = localStorage.getItem(TEST_REVAMP_STORAGE_KEY);
        if (key) {
            return false;
        }
        return true;
    }
    return false;
};

// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/NavBarItems.jsx




var MainItem = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("li", {
    target: "e2khoyd0",
    label: "MainItem"
})("padding:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, " ", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";> a,> span,> div{font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, ";font-size:", styleConstants/* Fonts.H4 */.F3.H4, ";line-height:", styleConstants/* Fonts.HEADER_LINE_HEIGHT */.F3.rm, ";margin:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";transition:color 400ms ease-in-out;opacity:", function(param) {
    var disabled = param.disabled;
    return disabled ? 0.5 : 1;
}, ";color:", function(param) {
    var selected = param.selected;
    return selected ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";:hover{color:", function(param) {
    var disabled = param.disabled;
    return disabled ? "inherit" : "var(--color-i-green)";
}, ";}@media only screen and (max-width:", styleConstants/* breakpoints.tablet */.AV.tablet, "){font-size:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";line-height:100%;}}");
var Item = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Link/* default */.Z, {
    target: "e2khoyd1",
    label: "Item"
})("margin:", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, " ", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";display:flex;font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";line-height:", styleConstants/* Fonts.HEADER_LINE_HEIGHT */.F3.rm, ";font-size:", styleConstants/* Fonts.LARGE */.F3.ln, ";position:relative;&.lastItem{margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";}align-items:center;.sideNavIcon{fill:", function(param) {
    var $selected = param.$selected, hovColor = param.hovColor;
    return $selected ? hovColor : null;
}, ";*{fill:", function(param) {
    var $selected = param.$selected, hovColor = param.hovColor;
    return $selected ? hovColor : null;
}, ";stroke:", function(param) {
    var $selected = param.$selected, hovColor = param.hovColor;
    return $selected ? hovColor : null;
}, ";}}&:hover{background-color:var(--color-base-1);cursor:pointer;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_1B */.t8.MK,
    blur: styleConstants/* Spacings.SPACING_4B */.t8.BM
}), ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";}&:hover .sideNavIcon{color:", function(param) {
    var hovColor = param.hovColor;
    return hovColor;
}, ";fill:", function(param) {
    var hovColor = param.hovColor;
    return hovColor;
}, ";*{fill:", function(param) {
    var hovColor = param.hovColor;
    return hovColor;
}, ";stroke:", function(param) {
    var hovColor = param.hovColor;
    return hovColor;
}, ";}}> a,> span,> div{transition:color 400ms ease-in-out;cursor:pointer;color:var(--color-text-primary);:hover{background-color:var(--color-base-1);}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";}}");

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/PracticeIcon.jsx




var SideNavPractice = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        gpath: "M68 40C68 55.464 55.464 68 40 68C24.536 68 12 55.464 12 40C12 24.536 24.536 12 40 12C55.464 12 68 24.536 68 40Z",
        path: "M48.6171 9.68425C48.6171 9.00906 48.1725 8.39913 47.4875 8.13464C46.8025 7.87015 46.0095 8.00223 45.4728 8.47022L38.869 14.2288C29.0364 22.8028 20.7282 32.7066 14.24 43.5878C14.0872 43.8325 14 44.1152 14 44.4165C14 45.3466 14.8315 46.1007 15.8571 46.1007H31.8657V70.3158C31.8657 70.9827 32.2997 71.5868 32.9724 71.8563C33.6451 72.1258 34.4298 72.01 34.9735 71.5608L37.9283 69.1199C48.2715 60.5753 57.0492 50.5922 63.9321 39.5453L65.7597 36.6119C66.0846 36.0905 66.0797 35.4518 65.7469 34.9345C65.414 34.4172 64.8033 34.0992 64.1429 34.0992H48.6171V9.68425Z"
    }));
};
/* harmony default export */ var PracticeIcon = (SideNavPractice);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/TestsIcon.jsx




var TestsIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        cx: "40",
        cy: "40",
        r: "28",
        path: "M74 28.502C74 26.2002 72.0323 24.3342 69.605 24.3342H52.0251C49.5978 24.3342 47.6301 26.2002 47.6301 28.502C47.6301 30.8038 49.5978 32.6698 52.0251 32.6698H69.605C72.0323 32.6698 74 30.8038 74 28.502Z M60.8156 41.0069C63.2429 41.0069 65.2106 39.1409 65.2106 36.8391V20.1678C65.2106 17.866 63.2429 16 60.8156 16C58.3884 16 56.4207 17.866 56.4207 20.1678L56.4207 36.8391C56.4207 39.1409 58.3884 41.0069 60.8156 41.0069Z M6.30906 58.3847C5.18247 61.078 7.27506 64 10.3304 64H12.1208C13.9423 64 15.5686 62.9181 16.1886 61.2939L18.8113 54.4232H39.5267L42.214 61.3195C42.8417 62.9304 44.461 64 46.272 64H48.0749C51.1326 64 53.2253 61.0737 52.0941 58.3798L35.4332 18.701C34.7779 17.1403 33.1854 16.1161 31.414 16.1161H26.9281C25.1546 16.1161 23.5608 17.1426 22.9068 18.706L6.30906 58.3847ZM21.8577 46.3302L29.0667 27.6491C29.0824 27.6084 29.1233 27.5813 29.169 27.5813C29.2147 27.5813 29.2556 27.6084 29.2713 27.6491L36.4803 46.3302H21.8577Z"
    }));
};
/* harmony default export */ var PlusNavBar_TestsIcon = (TestsIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/SyllabusIcon.jsx




var SyllabusIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        opacity: "0.3",
        gpath: "M66.4672 25.7249C70.962 28.4541 72.9767 33.966 71.1468 38.9608C69.7559 42.7571 68.0634 47.1252 66.4807 50.538C64.8981 53.9508 62.6572 58.0645 60.6578 61.5786C58.0273 66.2022 52.5183 68.2249 47.5314 66.557C39.6527 63.9218 32.0932 60.4163 24.992 56.1045C20.4966 53.375 18.4831 47.8622 20.3133 42.8668C21.7065 39.0645 23.4003 34.692 24.9775 31.2909C26.5548 27.8898 28.7982 23.7722 30.8007 20.2525C33.4315 15.6283 38.9403 13.6041 43.9279 15.2722C51.8066 17.9074 59.366 21.4132 66.4672 25.7249Z",
        path: "M59.1404 21.3897C58.8186 17.0323 55.4774 13.5315 51.1509 12.9219C42.4273 11.6928 33.5736 11.6927 24.8499 12.9218C20.5229 13.5315 17.1821 17.0334 16.8607 21.3913C16.4569 26.8656 16 34.316 16 40.0002C16 45.6843 16.4569 53.1347 16.8607 58.609C17.1821 62.9669 20.5229 66.4689 24.8499 67.0785C33.5736 68.3077 42.4273 68.3076 51.1509 67.0784C55.4774 66.4688 58.8186 62.968 59.1404 58.6106C59.5439 53.1454 60 45.7057 60 40.0002C60 34.2946 59.5439 26.855 59.1404 21.3897ZM47.8332 35.7847C49.0562 34.4087 48.9322 32.3018 47.5562 31.0788C46.1802 29.8559 44.0733 29.9799 42.8503 31.3559L33.9132 41.411L32.1189 39.3923C30.8959 38.0163 28.789 37.8923 27.413 39.1153C26.037 40.3383 25.913 42.4452 27.136 43.8212L31.4217 48.6431C32.0543 49.3547 32.961 49.762 33.9132 49.762C34.8653 49.762 35.7721 49.3547 36.4046 48.6431L47.8332 35.7847Z"
    }));
};
/* harmony default export */ var PlusNavBar_SyllabusIcon = (SyllabusIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/DoubtsIcon.jsx




var DoubtsIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        gpath: "M38.7288 62.7278C32.7763 68.6802 23.6922 69.5923 16.78 65.4641L11.6959 65.7317C10.8911 65.7741 10.2269 65.1099 10.2693 64.3051L10.5368 59.2216C6.40751 52.3092 7.31931 43.2242 13.2722 37.2712C16.2774 34.2661 20.0808 32.5456 24 32.1099V32H25.8124C25.9378 31.9987 26.0632 31.9987 26.1886 32H64V44H42.9762C45.209 50.3319 43.7932 57.6633 38.7288 62.7278Z",
        path: "M64.9229 21.3898C73.6251 31.1721 74.2181 45.359 67.1829 55.7178L67.1366 63.7133C67.1296 64.9304 66.0697 65.8732 64.8601 65.7385L56.9133 64.8532C45.8058 70.6335 31.7849 68.3922 23.083 58.6102C12.8048 47.0564 13.839 29.3581 25.3928 19.08C36.9466 8.80192 54.6448 9.83606 64.9229 21.3898ZM33.0029 44C34.6598 44 36.0029 42.6569 36.0029 41C36.0029 39.3431 34.6598 38 33.0029 38C31.3461 38 30.0029 39.3431 30.0029 41C30.0029 42.6569 31.3461 44 33.0029 44ZM48.0081 41C48.0081 42.6569 46.6649 44 45.0081 44C43.3512 44 42.0081 42.6569 42.0081 41C42.0081 39.3431 43.3512 38 45.0081 38C46.6649 38 48.0081 39.3431 48.0081 41ZM57.0002 44C58.6571 44 60.0002 42.6569 60.0002 41C60.0002 39.3431 58.6571 38 57.0002 38C55.3434 38 54.0002 39.3431 54.0002 41C54.0002 42.6569 55.3434 44 57.0002 44Z"
    }));
};
/* harmony default export */ var PlusNavBar_DoubtsIcon = (DoubtsIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/BrowseIcon.jsx




var SideNavEnrollments = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        gpath: "M63.9638 41.3301C63.9878 40.8898 64 40.4463 64 40C64 26.7452 53.2548 16 40 16C26.7452 16 16 26.7452 16 40C16 53.2548 26.7452 64 40 64C42.5066 64 44.9235 63.6157 47.1949 62.9029C49.7627 66.0157 53.6496 68 58 68C65.732 68 72 61.732 72 54C72 48.401 68.7132 43.5696 63.9638 41.3301Z",
        path: "M43.9014 40.0007C43.9014 42.0253 42.1382 43.8912 40.0109 43.8912C37.8836 43.8912 36.1204 42.0253 36.1204 40.0007C36.1204 37.9761 37.8836 36.1102 40.0109 36.1102C42.1382 36.1102 43.9014 37.9761 43.9014 40.0007Z",
        pathFillRule2: "evenodd",
        pathClipRule2: "evenodd",
        path2: "M40 68C55.464 68 68 55.464 68 40C68 24.536 55.464 12 40 12C24.536 12 12 24.536 12 40C12 55.464 24.536 68 40 68ZM23.4539 26.0774C22.4701 24.3266 24.5408 22.4633 26.3223 23.4964L45.3154 34.5096C45.6284 34.6911 45.8847 34.9491 46.0576 35.2568L56.5461 53.9226C57.5299 55.6734 55.4592 57.5367 53.6777 56.5036L34.6846 45.4904C34.3716 45.3089 34.1153 45.0509 33.9424 44.7432L23.4539 26.0774Z"
    }));
};
/* harmony default export */ var BrowseIcon = (SideNavEnrollments);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/OtherCoursesIcon.jsx




var OtherCourses = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        gpath: "M60 34C60 29.5817 56.4183 26 52 26H16C11.5817 26 8 29.5817 8 34V58C8 62.4183 11.5817 66 16 66H52C56.4183 66 60 62.4183 60 58V34Z",
        path: "M64 14C68.4183 14 72 17.5817 72 22V46C72 50.4183 68.4183 54 64 54H28C23.5817 54 20 50.4183 20 46V22C20 17.5817 23.5817 14 28 14H64ZM53.1736 32.3346C54.2755 33.1776 54.2755 34.8224 53.1736 35.6654C49.8436 38.2131 46.1251 40.2212 42.1574 41.6146L41.4326 41.8691C40.0459 42.3561 38.5811 41.4284 38.3934 40.013C37.8689 36.0584 37.8689 31.9416 38.3934 27.987C38.5811 26.5716 40.0459 25.6439 41.4326 26.1309L42.1574 26.3854C46.1251 27.7788 49.8436 29.7869 53.1736 32.3346Z"
    }));
};
/* harmony default export */ var OtherCoursesIcon = (OtherCourses);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/FreeLiveClassesIcon.jsx




var FreeLiveClasses = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        gpath: "M60 34C60 29.5817 56.4183 26 52 26H16C11.5817 26 8 29.5817 8 34V58C8 62.4183 11.5817 66 16 66H52C56.4183 66 60 62.4183 60 58V34Z",
        path: "M64 14C68.4183 14 72 17.5817 72 22V46C72 50.4183 68.4183 54 64 54H28C23.5817 54 20 50.4183 20 46V22C20 17.5817 23.5817 14 28 14H64ZM53.1736 32.3346C54.2755 33.1776 54.2755 34.8224 53.1736 35.6654C49.8436 38.2131 46.1251 40.2212 42.1574 41.6146L41.4326 41.8691C40.0459 42.3561 38.5811 41.4284 38.3934 40.013C37.8689 36.0584 37.8689 31.9416 38.3934 27.987C38.5811 26.5716 40.0459 25.6439 41.4326 26.1309L42.1574 26.3854C46.1251 27.7788 49.8436 29.7869 53.1736 32.3346Z"
    }));
};
/* harmony default export */ var FreeLiveClassesIcon = (FreeLiveClasses);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/LiveMentoringIcon.jsx




var LiveMentoringIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        pathFillRule: "evenodd",
        pathClipRule: "evenodd",
        gpath: "M24.1176 37.5064C19.2445 37.5064 15.2941 33.556 15.2941 28.6829C15.2941 23.8098 19.2445 19.8594 24.1176 19.8594C28.9907 19.8594 32.9412 23.8098 32.9412 28.6829C32.9412 33.556 28.9907 37.5064 24.1176 37.5064Z M34.5628 67.5064C20.9971 67.5064 10 56.5093 10 42.9436C10 41.89 10.8541 41.0358 11.9078 41.0358H32.9412C40.7381 41.0358 47.0588 47.3565 47.0588 55.1535V67.5064H34.5628Z",
        path: "M47.0593 37.5057C40.237 37.5057 34.7064 31.9751 34.7064 25.1527C34.7064 18.3304 40.237 12.7998 47.0593 12.7998C53.8817 12.7998 59.4123 18.3304 59.4123 25.1527C59.4123 31.9751 53.8817 37.5057 47.0593 37.5057Z M47.0593 67.5056C34.3893 67.5056 24.1182 57.2345 24.1182 44.5645V42.9429C24.1182 41.8892 24.9723 41.0351 26.026 41.0351H68.0927C69.1463 41.0351 70.0005 41.8892 70.0005 42.9429V44.5645C70.0005 57.2345 59.7294 67.5056 47.0593 67.5056Z"
    }));
};
/* harmony default export */ var PlusNavBar_LiveMentoringIcon = (LiveMentoringIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/SavedIcon.jsx




var SavedIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        gpath: "M60.063 13.0376C52.091 11.6541 43.9091 11.6541 35.937 13.0376C33.0245 13.543 30.7051 15.8574 30.1211 18.8583C27.4458 32.6061 27.2999 33.4196 29.6909 47.2234L30.6643 52.8435C30.9645 54.5764 33.0054 55.269 34.2385 54.0564L45.9887 55.8352C47.1158 54.7268 48.8842 54.7268 50.0113 55.8352L61.7615 67.3898C62.9946 68.6023 65.0355 67.9097 65.3357 66.1768L66.3091 60.5568C68.7001 46.7529 68.5542 32.6061 65.8789 18.8583C65.2949 15.8574 62.9755 13.543 60.063 13.0376Z",
        path: "M44.063 13.0376C36.091 11.6541 27.9091 11.6541 19.937 13.0376C17.0245 13.543 14.7051 15.8574 14.1211 18.8583C11.4458 32.6061 11.2999 46.7529 13.6909 60.5568L14.6643 66.1768C14.9645 67.9097 17.0054 68.6023 18.2385 67.3898L29.9887 55.8352C31.1158 54.7268 32.8842 54.7268 34.0113 55.8352L45.7615 67.3898C46.9946 68.6023 49.0355 67.9097 49.3357 66.1768L50.3091 60.5568C52.7001 46.7529 52.5542 32.6061 49.8789 18.8583C49.2949 15.8574 46.9755 13.543 44.063 13.0376Z"
    }));
};
/* harmony default export */ var PlusNavBar_SavedIcon = (SavedIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/CompeteIcon.jsx




var CompeteIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                clipPath: "url(#clip0_2412_287251)",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                        opacity: "0.3",
                        cx: "10",
                        cy: "10",
                        r: "7",
                        fill: "#7A8B94"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                        cx: "9.29728",
                        cy: "10.0688",
                        rx: "8.75",
                        ry: "3.75",
                        transform: "rotate(-150 9.29728 10.0688)",
                        stroke: "#7A8B94",
                        strokeWidth: "1",
                        style: {
                            fill: "transparent"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                        cx: "16.25",
                        cy: "3.75",
                        r: "1.25",
                        fill: "#7A8B94"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                        cx: "2.25684",
                        cy: "15.7803",
                        r: "1.25",
                        fill: "#7A8B94"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M17.6923 5.4763C17.436 5.69075 17.1311 5.84917 16.7966 5.93273C16.8921 6.20726 16.8991 6.54937 16.7901 6.96709C16.6526 7.49446 16.3375 8.10625 15.8456 8.76368C14.8631 10.077 13.2352 11.4924 11.1869 12.675C9.13861 13.8576 7.09887 14.5597 5.47025 14.7539C5.03969 14.8053 4.64481 14.8203 4.29061 14.8017C4.42466 15.0899 4.49951 15.4111 4.49951 15.7498C4.49951 15.7695 4.49926 15.7892 4.49875 15.8088C4.84646 15.8133 5.21145 15.7919 5.58867 15.7469C7.38126 15.5331 9.55011 14.7747 11.6869 13.541C13.8237 12.3073 15.5649 10.8083 16.6463 9.36272C17.1865 8.64074 17.5771 7.91202 17.7578 7.21954C17.9152 6.61608 17.9186 6.01374 17.6923 5.4763ZM14.3243 4.91487C14.1118 4.92174 13.888 4.93893 13.6535 4.96689C12.0249 5.16113 9.98518 5.86324 7.93689 7.04581C5.88861 8.22839 4.2607 9.6438 3.27817 10.9571C2.78632 11.6145 2.47123 12.2263 2.33364 12.7537C2.25994 13.0362 2.23929 13.2841 2.26316 13.4999L2.24951 13.4998C1.90368 13.4998 1.57607 13.5778 1.28332 13.7172C1.22274 13.326 1.25836 12.9139 1.36603 12.5012C1.5467 11.8088 1.93731 11.0801 2.47745 10.3581C3.5589 8.91254 5.30012 7.41346 7.43689 6.17979C9.57367 4.94612 11.7425 4.18773 13.5351 3.97393C13.6946 3.95491 13.8519 3.9401 14.0066 3.92969C14.035 4.28832 14.1475 4.62329 14.3243 4.91487Z",
                        fill: "#7A8B94",
                        strokeWidth: "0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
                    id: "clip0_2412_287251",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var PlusNavBar_CompeteIcon = (CompeteIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/SelfStudy.jsx

/* eslint-disable max-lines */ 



































var StySideNavPractice = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PracticeIcon, {
    target: "e1c49ght0",
    label: "StySideNavPractice"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyBrowseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(BrowseIcon, {
    target: "e1c49ght1",
    label: "StyBrowseIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyTestsIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_TestsIcon, {
    target: "e1c49ght2",
    label: "StyTestsIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StySyllabusIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_SyllabusIcon, {
    target: "e1c49ght3",
    label: "StySyllabusIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyNotesIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(notes_NavNotes, {
    target: "e1c49ght4",
    label: "StyNotesIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyDoubtsIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_DoubtsIcon, {
    target: "e1c49ght5",
    label: "StyDoubtsIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyFreeLiveClassesIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(FreeLiveClassesIcon, {
    target: "e1c49ght6",
    label: "StyFreeLiveClassesIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyPrintedNotesIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PrintedNotes_PrintedNotesIcon, {
    target: "e1c49ght7",
    label: "StyPrintedNotesIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyOtherCoursesIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(OtherCoursesIcon, {
    target: "e1c49ght8",
    label: "StyOtherCoursesIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyLiveMentoring = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_LiveMentoringIcon, {
    target: "e1c49ght9",
    label: "StyLiveMentoring"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StySideNavSaved = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_SavedIcon, {
    target: "e1c49ght10",
    label: "StySideNavSaved"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyCompete = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_CompeteIcon, {
    target: "e1c49ght11",
    label: "StyCompete"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var practiceUrls = [
    "".concat(goalHref, "/practice"),
    "".concat(goalHref, "/practice/topics"),
    "".concat(goalHref, "/practice/topics/[topicUID]"),
    "".concat(goalHref, "/practice/topics/[topicUID]/concept/[conceptUID]")
];
var IconDot = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "e1c49ght12",
    label: "IconDot"
})("width:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";height:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-radius:50%;background-color:var(--color-i-blue);position:absolute;top:25%;left:12%;border:1.6px solid var(--color-text-tertiary);&:hover{background-color:var(--color-i-blue) !important;}");
var getSelfStudyMap = function(param) {
    var route = param.route, handleClick = param.handleClick, isPracticeAvailable = param.isPracticeAvailable, isCompeteEnabled = param.isCompeteEnabled, isNoTestGoal = param.isNoTestGoal, hasPlusSubscription = param.hasPlusSubscription, isSubscribedToLite = param.isSubscribedToLite, liveMentoringEnabled = param.liveMentoringEnabled, isCatalogueFeatureAvailable = param.isCatalogueFeatureAvailable, selectedNav = param.selectedNav, goalAs = param.goalAs, isK12 = param.isK12, isAADEnabledFlag = param.isAADEnabledFlag, isNotesEnabledFlag = param.isNotesEnabledFlag, isLoggedIn = param.isLoggedIn, isSyllabusV1Enabled = param.isSyllabusV1Enabled, isGTP = param.isGTP, showBlueDotIconForDoubts = param.showBlueDotIconForDoubts, showBlueDotForTestRevamp = param.showBlueDotForTestRevamp, isRecordedGoal = param.isRecordedGoal, isPrintedNotesEnabledFlag = param.isPrintedNotesEnabledFlag, hasOfflineSubscription = param.hasOfflineSubscription;
    var isPracticeURL = practiceUrls.includes(route);
    var isTestSeriesURL = route === "".concat(goalHref, "/test-series");
    var isCompeteURL = route === "".concat(goalHref, "/compete");
    var isDoubtsAndSolutionVisited = cookies/* default.readCookie */.ZP.readCookie("doubtsAndSolutionVisited", false);
    var isSyllabusVisited = cookies/* default.readCookie */.ZP.readCookie("syllabusVisited", false);
    var isNotesVisited = cookies/* default.readCookie */.ZP.readCookie("notesVisited", false);
    var isPrintedNotesVisited = (0,utils_localStorage/* localStorageAvailable */.V)() ? localStorage.getItem("isPrintedNotesVisited") : false;
    var practiceHref = hasPlusSubscription || isSubscribedToLite || hasOfflineSubscription ? "".concat(goalHref, "/practice") : "".concat(goalHref, "/practice/topics");
    var practiceAs = hasPlusSubscription || isSubscribedToLite || hasOfflineSubscription ? "".concat(goalAs, "/practice") : "".concat(goalAs, "/practice/topics");
    var selfStudyMap = [
        {
            label: "Browse",
            dataId: plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            isSelected: route === "".concat(goalHref, "/browse") || selectedNav === plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            href: "".concat(goalHref, "/browse"),
            as: "".concat(goalAs, "/browse"),
            itemHandleClick: handleClick(plusNavBarItems/* default.BROWSE */.Z.BROWSE, "".concat(goalHref, "/browse"), "".concat(goalAs, "/browse")),
            key: plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            isShown: true,
            icon: StyBrowseIcon,
            hovColor: "var(--color-i-turquoise-6)"
        },
        {
            label: "Compete",
            dataId: plusNavBarItems/* default.COMPETE */.Z.COMPETE,
            isSelected: isCompeteURL || selectedNav === plusNavBarItems/* default.COMPETE */.Z.COMPETE,
            href: "".concat(goalHref, "/compete"),
            as: "".concat(goalAs, "/compete"),
            itemHandleClick: handleClick(plusNavBarItems/* default.COMPETE */.Z.COMPETE, "".concat(goalHref, "/compete"), "".concat(goalAs, "/compete")),
            key: plusNavBarItems/* default.COMPETE */.Z.COMPETE,
            isShown: isCompeteEnabled,
            icon: StyCompete,
            hovColor: "var(--color-i-blue-20)"
        },
        {
            label: "Practice",
            dataId: plusNavBarItems/* default.PRACTICE */.Z.PRACTICE,
            isSelected: isPracticeURL,
            href: practiceHref,
            as: practiceAs,
            itemHandleClick: handleClick(plusNavBarItems/* default.PRACTICE */.Z.PRACTICE, practiceHref, practiceAs),
            key: plusNavBarItems/* default.PRACTICE */.Z.PRACTICE,
            isShown: isPracticeAvailable,
            icon: StySideNavPractice,
            hovColor: "var(--color-i-violet-12)"
        },
        {
            label: "Tests",
            dataId: plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES,
            isSelected: isTestSeriesURL,
            href: "".concat(goalHref, "/test-series"),
            as: "".concat(goalAs, "/test-series"),
            itemHandleClick: handleClick(plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES, "".concat(goalHref, "/test-series"), "".concat(goalAs, "/test-series")),
            key: plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES,
            isShown: !isNoTestGoal,
            icon: StyTestsIcon,
            showDot: showBlueDotForTestRevamp,
            hovColor: "var(--color-i-blue-20)"
        },
        {
            label: isRecordedGoal ? "Video Lessons" : plusNavBarItems/* default.PLAYLIST */.Z.PLAYLIST,
            dataId: plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            isSelected: selectedNav === plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            href: "".concat(goalHref, "/topics"),
            as: "".concat(goalAs, "/topics"),
            itemHandleClick: handleClick(isRecordedGoal ? plusNavBarItems/* default.VIDEO_LESSONS */.Z.VIDEO_LESSONS : plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS, "".concat(goalHref, "/topics"), "".concat(goalAs, "/topics")),
            key: plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            isShown: true,
            icon: StySyllabusIcon,
            showDot: isSyllabusV1Enabled && !isSyllabusVisited,
            hovColor: "var(--color-i-green-8)"
        },
        {
            label: "Doubts & solutions",
            dataId: plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS,
            isSelected: selectedNav === plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS,
            href: "".concat(goalHref, "/doubts-and-solutions"),
            as: "".concat(goalAs, "/doubts-and-solutions"),
            itemHandleClick: handleClick(plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS, "".concat(goalHref, "/doubts-and-solutions"), "".concat(goalAs, "/doubts-and-solutions")),
            key: plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS,
            isShown: !isLoggedIn || isCatalogueFeatureAvailable || isAADEnabledFlag || isSubscribedToLite,
            icon: StyDoubtsIcon,
            showDot: !isDoubtsAndSolutionVisited || showBlueDotIconForDoubts,
            hovColor: "var(--color-i-green-9)"
        },
        {
            label: "Notes",
            dataId: plusNavBarItems/* default.NOTES */.Z.NOTES,
            isSelected: selectedNav === plusNavBarItems/* default.NOTES */.Z.NOTES,
            href: "".concat(goalHref, "/notes"),
            as: "".concat(goalAs, "/notes"),
            itemHandleClick: handleClick(plusNavBarItems/* default.NOTES */.Z.NOTES, "".concat(goalHref, "/notes"), "".concat(goalAs, "/notes")),
            key: plusNavBarItems/* default.NOTES */.Z.NOTES,
            isShown: isLoggedIn && (hasPlusSubscription || hasOfflineSubscription) && isNotesEnabledFlag,
            icon: StyNotesIcon,
            showDot: !isNotesVisited,
            hovColor: "var(--color-i-yellow-4)"
        },
        {
            label: "Free live classes",
            dataId: plusNavBarItems/* default.FREE_CLASSES_AND_TESTS */.Z.FREE_CLASSES_AND_TESTS,
            isSelected: selectedNav === plusNavBarItems/* default.FREE_CLASSES_AND_TESTS */.Z.FREE_CLASSES_AND_TESTS,
            href: "".concat(goalHref, "/classes"),
            as: "".concat(goalAs, "/classes"),
            itemHandleClick: handleClick(plusNavBarItems/* default.FREE_CLASSES_AND_TESTS */.Z.FREE_CLASSES_AND_TESTS, "".concat(goalHref, "/classes"), "".concat(goalAs, "/classes")),
            key: plusNavBarItems/* default.FREE_CLASSES_AND_TESTS */.Z.FREE_CLASSES_AND_TESTS,
            isShown: true,
            icon: StyFreeLiveClassesIcon,
            hovColor: "var(--color-i-red-1)"
        },
        {
            label: isK12 ? "Live homework help" : "1:1 Live mentorship",
            dataId: plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP,
            isSelected: selectedNav === plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP,
            href: "".concat(goalHref, "/one-to-one-livementorship"),
            as: "".concat(goalAs, "/one-to-one-livementorship"),
            itemHandleClick: handleClick(plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP, "".concat(goalHref, "/one-to-one-livementorship"), "".concat(goalAs, "/one-to-one-livementorship")),
            linkHandleClick: handleClick(plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP),
            hasPlusSubscription: hasPlusSubscription,
            key: plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP,
            isShown: liveMentoringEnabled,
            icon: StyLiveMentoring,
            hovColor: "var(--color-i-blue-18)"
        },
        {
            label: AddressCollection_constants/* printedNotesPageName */.qH,
            dataId: plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES,
            isSelected: selectedNav === plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES,
            href: "".concat(goalHref, "/address-collection"),
            as: "".concat(goalAs, "/address-collection"),
            itemHandleClick: handleClick(plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES, "".concat(goalHref, "/address-collection"), "".concat(goalAs, "/address-collection")),
            key: plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES,
            isShown: isLoggedIn && isPrintedNotesEnabledFlag,
            icon: StyPrintedNotesIcon,
            showDot: !isPrintedNotesVisited,
            hovColor: "var(--color-i-yellow-7)"
        },
        {
            label: "Other courses",
            dataId: plusNavBarItems/* default.FREE_PLATFORM */.Z.FREE_PLATFORM,
            isSelected: selectedNav === plusNavBarItems/* default.FREE_PLATFORM */.Z.FREE_PLATFORM,
            href: "".concat(goalHref, "/free-platform"),
            as: "".concat(goalAs, "/free-platform"),
            itemHandleClick: handleClick(plusNavBarItems/* default.FREE_PLATFORM */.Z.FREE_PLATFORM, "".concat(goalHref, "/free-platform"), "".concat(goalAs, "/free-platform")),
            key: plusNavBarItems/* default.FREE_PLATFORM */.Z.FREE_PLATFORM,
            isShown: !(hasPlusSubscription || hasOfflineSubscription),
            icon: StyOtherCoursesIcon,
            hovColor: "var(--color-i-gray-17)"
        }
    ];
    var gtpSelfStudyMap = [
        {
            label: "Browse",
            dataId: plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            isSelected: route === "".concat(goalHref, "/browse") || selectedNav === plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            href: "".concat(goalHref, "/browse"),
            as: "".concat(goalAs, "/browse"),
            itemHandleClick: handleClick(plusNavBarItems/* default.BROWSE */.Z.BROWSE, "".concat(goalHref, "/browse"), "".concat(goalAs, "/browse")),
            key: plusNavBarItems/* default.BROWSE */.Z.BROWSE,
            isShown: true,
            icon: StyBrowseIcon,
            hovColor: "var(--color-i-turquoise-6)"
        },
        {
            label: "Video lessons",
            dataId: plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            isSelected: selectedNav === plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            href: "".concat(goalHref, "/topics"),
            as: "".concat(goalAs, "/topics"),
            itemHandleClick: handleClick(plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS, "".concat(goalHref, "/topics"), "".concat(goalAs, "/topics")),
            key: plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS,
            isShown: true,
            icon: StyFreeLiveClassesIcon,
            showDot: isSyllabusV1Enabled && !isSyllabusVisited,
            hovColor: "var(--color-i-red-1)"
        },
        {
            label: "Practice",
            dataId: plusNavBarItems/* default.PRACTICE */.Z.PRACTICE,
            isSelected: isPracticeURL,
            href: practiceHref,
            as: practiceAs,
            itemHandleClick: handleClick(plusNavBarItems/* default.PRACTICE */.Z.PRACTICE, practiceHref, practiceAs),
            key: plusNavBarItems/* default.PRACTICE */.Z.PRACTICE,
            isShown: true,
            icon: StySideNavPractice,
            hovColor: "var(--color-i-violet-12)"
        },
        {
            label: "Tests",
            dataId: plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES,
            isSelected: isTestSeriesURL,
            href: "".concat(goalHref, "/test-series"),
            as: "".concat(goalAs, "/test-series"),
            itemHandleClick: handleClick(plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES, "".concat(goalHref, "/test-series"), "".concat(goalAs, "/test-series")),
            key: plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES,
            isShown: true,
            icon: StyTestsIcon,
            hovColor: "var(--color-i-blue-20)"
        },
        {
            label: "Saved",
            dataId: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isSelected: selectedNav === plusNavBarItems/* default.SAVED */.Z.SAVED,
            href: "".concat(goalHref, "/saved"),
            as: "".concat(goalAs, "/saved"),
            itemHandleClick: handleClick(plusNavBarItems/* default.SAVED */.Z.SAVED, "".concat(goalHref, "/saved"), "".concat(goalAs, "/saved")),
            key: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isShown: hasPlusSubscription,
            hovColor: "var(--color-i-orange-11)",
            icon: StySideNavSaved
        }
    ];
    if (isRecordedGoal) {
        return algos/* default.moveArrayElement */.Z.moveArrayElement(selfStudyMap, 3, 1);
    }
    return isGTP ? gtpSelfStudyMap : selfStudyMap;
};
var isLiveMentoringEnabled = function() {
    var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ele = array.find(function(feature) {
        return feature.type === src_constants/* sideNavFlags.ONE_TO_ONE_LIVE_MENTORING */.eo.ONE_TO_ONE_LIVE_MENTORING;
    });
    return !!ele;
};
var isAADEnabled = function() {
    var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ele = array.find(function(feature) {
        return feature.type === src_constants/* sideNavFlags.DOUBTS_AND_SOLUTIONS */.eo.DOUBTS_AND_SOLUTIONS;
    });
    var ele2 = ele === null || ele === void 0 ? void 0 : ele.isAskADoubtEnabled;
    return !!ele2;
};
var isNotesEnabled = function() {
    var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ele = array.find(function(feature) {
        return feature.type === src_constants/* sideNavFlags.NOTES */.eo.NOTES;
    });
    return !!ele;
};
var SelfStudy = function(param) {
    var handleClick = param.handleClick, selectedNav = param.selectedNav, goalUID = param.goalUID, goalAs = param.goalAs, hasPlusSubscription = param.hasPlusSubscription, isCatalogueFeatureAvailable = param.isCatalogueFeatureAvailable, hasOfflineSubscription = param.hasOfflineSubscription;
    var route = (0,next_router.useRouter)().route;
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var ref = (0,useTopology/* default */.Z)(goalUID), goalInfo = ref.topology;
    var isPracticeAvailable = getIsPracticeAvailable(goalInfo) || isGTP;
    var isNoTestGoal = getIsNoTestGoal(goalInfo);
    var isSyllabusV1Enabled = getIsSyllabusV1Enabled(goalInfo);
    var sidenavFlags = (0,useSidenavFlags/* default */.Z)(goalUID).sidenavFlags;
    var features = (sidenavFlags || {
        features: []
    }).features;
    var isK12 = goalInfo.isK12, isRecordedGoal = goalInfo.isRecordedGoal;
    var liveMentoringEnabled = isLiveMentoringEnabled(features);
    var isAADEnabledFlag = isAADEnabled(features);
    var isNotesEnabledFlag = isNotesEnabled(features);
    var isPrintedNotesEnabledFlag = (0,AddressCollection_constants/* isPrintedNotesEnabled */.sT)(features);
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var isSubscribedToLite = (0,useMyInfo/* default */.Z)((0,subscription/* getIsSubscribedToLite */.aA)(goalUID));
    var isTestRevampGoal = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsTestRevampGoal */.ur)(goalUID));
    var isCompeteEnabled = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsCompeteEnabled */.xs)(goalUID));
    var showBlueDotForTestRevamp = getIsBlueDotshownForTestRevamp(isTestRevampGoal);
    var data = planner_useBottomSheetDetails(goalUID).data;
    var _adoption_dot = data.adoption_dot, adoption_dot = _adoption_dot === void 0 ? {} : _adoption_dot;
    var tmp = adoption_dot.self_study, selfStudy = tmp === void 0 ? [] : tmp;
    var doubtDotDetails = selfStudy.find(function(item) {
        return item.feature === Doubts20_constants/* blueDotFeature.DOUBTS */.A.DOUBTS;
    });
    var showBlueDotIconForDoubts = doubtDotDetails === null || doubtDotDetails === void 0 ? void 0 : doubtDotDetails.show_dot;
    var tabsMap = getSelfStudyMap({
        route: route,
        handleClick: handleClick,
        isPracticeAvailable: isPracticeAvailable,
        isCompeteEnabled: isCompeteEnabled,
        isNoTestGoal: isNoTestGoal,
        hasPlusSubscription: hasPlusSubscription,
        isSubscribedToLite: isSubscribedToLite,
        liveMentoringEnabled: liveMentoringEnabled,
        isCatalogueFeatureAvailable: isCatalogueFeatureAvailable,
        selectedNav: selectedNav,
        goalAs: goalAs,
        isK12: isK12,
        isAADEnabledFlag: isAADEnabledFlag,
        isNotesEnabledFlag: isNotesEnabledFlag,
        isLoggedIn: isLoggedIn,
        isSyllabusV1Enabled: isSyllabusV1Enabled,
        isGTP: isGTP,
        showBlueDotIconForDoubts: showBlueDotIconForDoubts,
        showBlueDotForTestRevamp: showBlueDotForTestRevamp,
        isRecordedGoal: isRecordedGoal,
        isPrintedNotesEnabledFlag: isPrintedNotesEnabledFlag,
        hasOfflineSubscription: hasOfflineSubscription
    });
    var isMounted = (0,useMounted/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            !isGTP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH7, {
                $isLite: isSubscribedToLite || isRecordedGoal,
                children: "SELF STUDY"
            }),
            tabsMap.filter(function(item) {
                return item && item.isShown;
            }).map(function(item) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                    $selected: item.isSelected,
                    "data-id": item.dataId,
                    hovColor: item.hovColor,
                    href: item.href,
                    as: item.as,
                    onClick: item.itemHandleClick,
                    prefetch: true,
                    children: [
                        isMounted && item.showDot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconDot, {}),
                        item.icon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(item.icon, {
                            size: "20px",
                            color: item.isSelected ? item.hovColor : "var(--color-text-secondary)",
                            className: "sideNavIcon"
                        }) : null,
                        item.label
                    ]
                }, item.key);
            })
        ]
    });
};
/* harmony default export */ var PlusNavBar_SelfStudy = (SelfStudy);
SelfStudy.propTypes = {
    handleClick: (prop_types_default()).func.isRequired,
    selectedNav: (prop_types_default()).string,
    goalUID: (prop_types_default()).string.isRequired
};
SelfStudy.defaultProps = {
    selectedNav: ""
};

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/EnrollmentsIcon.jsx




var EnrollmentsIcon_SideNavEnrollments = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        gpath: "M15.015 16.6748C15.3049 14.432 16.9917 12.6233 19.2088 12.1778C32.9324 9.42017 47.0676 9.42017 60.7912 12.1778C63.0083 12.6233 64.695 14.432 64.985 16.6748L66.0115 24.6166C67.3317 34.8297 67.3317 45.1703 66.0115 55.3834L64.985 63.3252C64.695 65.568 63.0083 67.3767 60.7912 67.8222C47.0676 70.5798 32.9324 70.5798 19.2088 67.8222C16.9917 67.3767 15.3049 65.568 15.015 63.3252L13.9885 55.3834C12.6683 45.1703 12.6683 34.8297 13.9885 24.6166L15.015 16.6748Z",
        path: "M17.9902 18.9029C14.41 19.375 11.5298 22.0783 10.8319 25.6214L10.6916 26.3339C8.91401 35.3583 8.91401 44.6428 10.6916 53.6673L10.8319 54.3797C11.5298 57.9229 14.41 60.6261 17.9902 61.0982C32.5999 63.0248 47.3993 63.0248 62.009 61.0982C65.5893 60.6261 68.4695 57.9229 69.1674 54.3797L69.3077 53.6673C71.0852 44.6428 71.0852 35.3583 69.3077 26.3339L69.1674 25.6214C68.4695 22.0783 65.5893 19.375 62.009 18.9029C47.3993 16.9764 32.5999 16.9764 17.9902 18.9029ZM48.9669 37.9178C50.3442 38.9716 50.3442 41.0276 48.9669 42.0814C44.8043 45.266 40.1563 47.7761 35.1967 49.5178L34.2906 49.836C32.5572 50.4447 30.7263 49.2851 30.4916 47.5159C29.836 42.5727 29.836 37.4266 30.4916 32.4833C30.7263 30.7141 32.5572 29.5545 34.2906 30.1632L35.1967 30.4814C40.1563 32.2231 44.8043 34.7332 48.9669 37.9178Z"
    }));
};
/* harmony default export */ var EnrollmentsIcon = (EnrollmentsIcon_SideNavEnrollments);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/MeSection.jsx
















var StySideNavEnrollments = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(EnrollmentsIcon, {
    target: "e1whkcqh0",
    label: "StySideNavEnrollments"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var MeSection_StySideNavSaved = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_SavedIcon, {
    target: "e1whkcqh1",
    label: "StySideNavSaved"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var getMeSectionTouchPoints = function(handleClick, goalAs, hasPlusSubscription, hasLiteSubscription, selectedNav) {
    return [
        {
            label: "Enrollments",
            dataId: plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS,
            isSelected: selectedNav === plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS,
            href: "".concat(goalHref, "/enrolled"),
            as: "".concat(goalAs, "/enrolled"),
            itemHandleClick: handleClick(plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS, "".concat(goalHref, "/enrolled"), "".concat(goalAs, "/enrolled")),
            key: plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS,
            isShown: hasPlusSubscription || hasLiteSubscription,
            hovColor: "var(--color-i-turquoise-4)",
            icon: StySideNavEnrollments
        },
        {
            label: "Saved",
            dataId: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isSelected: selectedNav === plusNavBarItems/* default.SAVED */.Z.SAVED,
            href: "".concat(goalHref, "/saved"),
            as: "".concat(goalAs, "/saved"),
            itemHandleClick: handleClick(plusNavBarItems/* default.SAVED */.Z.SAVED, "".concat(goalHref, "/saved"), "".concat(goalAs, "/saved")),
            key: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isShown: hasPlusSubscription || hasLiteSubscription,
            hovColor: "var(--color-i-orange-11)",
            icon: MeSection_StySideNavSaved
        }
    ];
};
var MeSection = function(param) {
    var handleClick = param.handleClick, selectedNav = param.selectedNav, goalAs = param.goalAs;
    var router = (0,next_router.useRouter)();
    var _query = router.query, selectedGoalFromURL = _query.goalUID;
    var selectedGoalFromStore = (0,useSelectedGoal/* useSelectedGoalUID */.Xm)();
    var selectedGoal = selectedGoalFromURL || selectedGoalFromStore;
    var me = (0,useMyInfo/* default */.Z)(auth/* getMe */.jo);
    var ref = (0,useTopology/* default */.Z)(selectedGoal), goalInfo = ref.topology;
    var hasPlusSubscription = (0,subscription/* getIsSubscribedToPlus */.FZ)(me, goalInfo.uid || selectedGoal);
    var hasLiteSubscription = (0,subscription/* getIsSubscribedToLite */.aA)(me, goalInfo.uid || selectedGoal);
    var tabsMap = getMeSectionTouchPoints(handleClick, goalAs, hasPlusSubscription, hasLiteSubscription, selectedNav);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH7, {
                children: "ME"
            }),
            tabsMap.filter(function(item) {
                return item.isShown;
            }).map(function(item) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                    $selected: item.isSelected,
                    "data-id": item.dataId,
                    onClick: item.itemHandleClick,
                    className: item.key === plusNavBarItems/* default.SAVED */.Z.SAVED ? "lastItem" : null,
                    hovColor: item.hovColor,
                    href: item.href,
                    as: item.as,
                    prefetch: true,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(item.icon, {
                            size: "20px",
                            color: item.isSelected ? item.hovColor : "var(--color-text-secondary)",
                            className: "sideNavIcon"
                        }),
                        item.label
                    ]
                }, item.key);
            })
        ]
    });
};
/* harmony default export */ var PlusNavBar_MeSection = (MeSection);
MeSection.propTypes = {
    handleClick: (prop_types_default()).func.isRequired,
    selectedNav: (prop_types_default()).string
};
MeSection.defaultProps = {
    selectedNav: ""
};

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/PlannerIcon.jsx




var PlannerIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        cx: "60",
        cy: "56",
        r: "16",
        path: "M26.7192 16.2584C26.7192 15.0111 25.6699 14 24.3755 14C23.0811 14 22.0318 15.0111 22.0318 16.2584V21.7279C17.3661 22.3635 13.6801 25.9195 13.0561 30.4555L12.7856 32.4216C12.7398 32.7549 12.6959 33.0885 12.6541 33.4222C12.5431 34.3073 13.2669 35.0781 14.1922 35.0781H65.8078C66.7331 35.0781 67.4569 34.3073 67.3459 33.4222C67.3041 33.0885 67.2602 32.7549 67.2144 32.4216L66.9439 30.4554C66.3199 25.9195 62.634 22.3636 57.9684 21.7279V16.2584C57.9684 15.0111 56.9191 14 55.6247 14C54.3303 14 53.281 15.0111 53.281 16.2584V21.2799C44.4446 20.5216 35.5556 20.5216 26.7192 21.2798V16.2584Z",
        path2: "M67.9511 41.0267C67.9238 40.2245 67.2358 39.5948 66.4028 39.5948H13.5972C12.7642 39.5948 12.0762 40.2245 12.0489 41.0267C11.8633 46.4699 12.2064 51.9242 13.0774 57.318C13.7368 61.4012 17.1794 64.5375 21.4472 64.9431L25.1753 65.2973C35.0345 66.2342 44.9655 66.2342 54.8247 65.2973L58.5528 64.9431C62.8206 64.5375 66.2632 61.4012 66.9226 57.318C67.7936 51.9242 68.1367 46.4699 67.9511 41.0267Z"
    }));
};
/* harmony default export */ var PlusNavBar_PlannerIcon = (PlannerIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/PlannerItem.jsx








var StyPlannerIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_PlannerIcon, {
    target: "eb3gj700",
    label: "StyPlannerIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var StyledItem = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Item, {
    target: "eb3gj701",
    label: "StyledItem"
})("margin-bottom:0;");
var itemHoverColor = "var(--color-i-red-1)";
var PlannerItem = function(param) {
    var handleClick = param.handleClick, isSelected = param.isSelected, goalAs = param.goalAs;
    var plannerHref = "".concat(goalHref, "/planner");
    var as = "".concat(goalAs, "/planner");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledItem, {
        $selected: isSelected,
        "data-id": plusNavBarItems/* default.SCHEDULE */.Z.SCHEDULE,
        onClick: handleClick(plusNavBarItems/* default.SCHEDULE */.Z.SCHEDULE, plannerHref, as),
        hovColor: itemHoverColor,
        href: plannerHref,
        as: as,
        prefetch: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyPlannerIcon, {
                size: "20px",
                color: isSelected ? itemHoverColor : "var(--color-text-secondary)",
                className: "sideNavIcon"
            }),
            "Planner"
        ]
    });
};
PlannerItem.propTypes = {
    handleClick: (prop_types_default()).func.isRequired,
    isSelected: (prop_types_default()).bool.isRequired,
    goalAs: (prop_types_default()).string.isRequired
};
/* harmony default export */ var PlusNavBar_PlannerItem = (PlannerItem);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/HomeIcon.jsx




var HomeIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        opacity: ".3",
        gpath: "M56 12C53.7909 12 52 13.7909 52 16V40C52 42.2091 53.7909 44 56 44H64C66.2091 44 68 42.2091 68 40V16C68 13.7909 66.2091 12 64 12H56Z M32 48C29.7909 48 28 49.7909 28 52V68H52V52C52 49.7909 50.2091 48 48 48H32Z",
        path: "M34.5342 14.1681C37.6099 11.2903 42.3901 11.2903 45.4658 14.1681L65.4658 32.881C67.0825 34.3936 68 36.5086 68 38.7227V59.9997C68 64.418 64.4183 67.9997 60 67.9997H49.6C48.7163 67.9997 48 67.2833 48 66.3997V56.0003C48 51.5821 44.4183 48.0003 40 48.0003C35.5817 48.0003 32 51.5821 32 56.0003V66.3997C32 67.2833 31.2837 67.9997 30.4 67.9997H20C15.5817 67.9997 12 64.418 12 59.9997V38.7227C12 36.5086 12.9175 34.3936 14.5342 32.881L34.5342 14.1681Z"
    }));
};
/* harmony default export */ var PlusNavBar_HomeIcon = (HomeIcon);

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/Home.jsx








var StySideNavHome = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_HomeIcon, {
    target: "ehyc4ov0",
    label: "StySideNavHome"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var hovColor = "var(--color-i-blue-18)";
var Home = function(param) {
    var handleClick = param.handleClick, isSelected = param.isSelected, goalAs = param.goalAs;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
        $selected: isSelected,
        "data-id": plusNavBarItems/* default.PLUS_HOME */.Z.PLUS_HOME,
        onClick: handleClick(plusNavBarItems/* default.PLUS_HOME */.Z.PLUS_HOME, false, true, goalHref, goalAs),
        hovColor: hovColor,
        href: goalHref,
        as: goalAs,
        prefetch: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StySideNavHome, {
                size: "20px",
                color: isSelected ? hovColor : "var(--color-text-secondary)",
                className: "sideNavIcon"
            }),
            "Home"
        ]
    });
};
/* harmony default export */ var PlusNavBar_Home = (Home);
Home.propTypes = {
    handleClick: (prop_types_default()).func.isRequired,
    isSelected: (prop_types_default()).bool.isRequired,
    goalAs: (prop_types_default()).string.isRequired
};

// EXTERNAL MODULE: ./src/components/Container/BatchGroup/constants/index.js
var BatchGroup_constants = __webpack_require__(10736);
;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/PlatformNavItems.jsx












var StyleSideNavHome = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_HomeIcon, {
    target: "ef1sydq0",
    label: "StyleSideNavHome"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var PlatformNavItems_StySideNavSaved = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlusNavBar_SavedIcon, {
    target: "ef1sydq1",
    label: "StySideNavSaved"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var PlatformNavItems_StyBrowseIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(BrowseIcon, {
    target: "ef1sydq2",
    label: "StyBrowseIcon"
})("margin-right:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var PlatformNavItems_IconDot = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "ef1sydq3",
    label: "IconDot"
})("width:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";height:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-radius:50%;background-color:var(--color-i-blue);position:absolute;top:25%;left:12%;border:1.6px solid var(--color-text-tertiary);&:hover{background-color:var(--color-i-blue) !important;}");
var getNavigationMap = function(param) {
    var route = param.route, handleClick = param.handleClick, selectedNav = param.selectedNav, goalAs = param.goalAs;
    var navigationMap = [
        {
            label: "Home",
            dataId: plusNavBarItems/* default.ENROLLMENTS_BATCH */.Z.ENROLLMENTS_BATCH,
            isSelected: route === "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.home */.GZ.home) || selectedNav === plusNavBarItems/* default.ENROLLMENTS_BATCH */.Z.ENROLLMENTS_BATCH,
            href: "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.home */.GZ.home),
            as: "".concat(goalAs, "/").concat(BatchGroup_constants/* batchGroupNave.home */.GZ.home),
            itemHandleClick: handleClick(plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS, "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.home */.GZ.home), "".concat(goalAs, "/").concat(BatchGroup_constants/* batchGroupNave.home */.GZ.home)),
            key: plusNavBarItems/* default.ENROLLMENTS_BATCH */.Z.ENROLLMENTS_BATCH,
            isShown: true,
            icon: StyleSideNavHome,
            hovColor: "var(--color-i-blue-18)"
        },
        {
            label: "Browse",
            dataId: plusNavBarItems/* default.UPCOMING_BATCHES */.Z.UPCOMING_BATCHES,
            isSelected: route === "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.browse */.GZ.browse) || selectedNav === plusNavBarItems/* default.UPCOMING_BATCHES */.Z.UPCOMING_BATCHES,
            href: "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.browse */.GZ.browse),
            as: "".concat(goalAs, "/").concat(BatchGroup_constants/* batchGroupNave.browse */.GZ.browse),
            itemHandleClick: handleClick(plusNavBarItems/* default.UPCOMING_BATCHES */.Z.UPCOMING_BATCHES, "".concat(goalHref, "/").concat(BatchGroup_constants/* batchGroupNave.browse */.GZ.browse), "".concat(goalAs, "/").concat(BatchGroup_constants/* batchGroupNave.browse */.GZ.browse)),
            key: plusNavBarItems/* default.UPCOMING_BATCHES */.Z.UPCOMING_BATCHES,
            isShown: true,
            icon: PlatformNavItems_StyBrowseIcon,
            hovColor: "var(--color-i-turquoise-6)"
        },
        {
            label: "Saved",
            dataId: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isSelected: route === "".concat(goalHref, "/saved") || selectedNav === plusNavBarItems/* default.SAVED */.Z.SAVED,
            href: "".concat(goalHref, "/saved"),
            as: "".concat(goalAs, "/saved"),
            itemHandleClick: handleClick(plusNavBarItems/* default.SAVED */.Z.SAVED, "".concat(goalHref, "/saved"), "".concat(goalAs, "/saved")),
            key: plusNavBarItems/* default.SAVED */.Z.SAVED,
            isShown: true,
            icon: PlatformNavItems_StySideNavSaved,
            hovColor: "var(--color-i-red-1)"
        }
    ];
    return navigationMap;
};
var PlatformNavItems = function(param) {
    var handleClick = param.handleClick, selectedNav = param.selectedNav, goalAs = param.goalAs;
    var route = (0,next_router.useRouter)().route;
    var tabsMap = getNavigationMap({
        route: route,
        handleClick: handleClick,
        selectedNav: selectedNav,
        goalAs: goalAs
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: tabsMap.filter(function(item) {
            return item && item.isShown;
        }).map(function(item) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                $selected: item.isSelected,
                "data-id": item.dataId,
                onClick: item.itemHandleClick,
                hovColor: item.hovColor,
                href: item.href,
                as: item.as,
                prefetch: true,
                children: [
                    item.showDot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlatformNavItems_IconDot, {}),
                    item.icon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(item.icon, {
                        size: "20px",
                        color: item.isSelected ? item.hovColor : "var(--color-text-secondary)",
                        className: "sideNavIcon"
                    }) : null,
                    item.label
                ]
            }, item.key);
        })
    });
};
/* harmony default export */ var PlusNavBar_PlatformNavItems = (PlatformNavItems);
PlatformNavItems.propTypes = {
    handleClick: (prop_types_default()).func.isRequired,
    selectedNav: (prop_types_default()).string
};
PlatformNavItems.defaultProps = {
    selectedNav: ""
};

;// CONCATENATED MODULE: ./src/layout/NavBar/PlusNavBar/PlusNavBar.jsx



































var DEFAULT_ITEM_HEIGHT = 37;
var Selected = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ersq9d30",
    label: "Selected"
})("visibility:", function(param) {
    var $isVisible = param.$isVisible;
    return $isVisible ? "visible" : "hidden";
}, ";height:", DEFAULT_ITEM_HEIGHT, "px;width:calc(100% - 40px);position:absolute;background-color:var(--color-base-1);top:0px;transform-origin:top;transform:", function(param) {
    var $posY = param.$posY, $scaleY = param.$scaleY;
    return "translateY(".concat($posY, "px) scaleY(").concat($scaleY, ")");
}, ";transition:transform 400ms ease-in,visibility 400ms;border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_4B */.t8.BM,
    blur: styleConstants/* Spacings.SPACING_8B */.t8.B3
}), ";");
var _obj;
var navKeyEventNameMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.PLUS_HOME */.Z.PLUS_HOME, "Home - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.SCHEDULE */.Z.SCHEDULE, "Planner - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.FREE_CLASSES_AND_TESTS */.Z.FREE_CLASSES_AND_TESTS, "Free Live Classes - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.FREE_PLATFORM */.Z.FREE_PLATFORM, "Other Courses - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.PRACTICE */.Z.PRACTICE, segment/* PRACTICE_SECTION_CLICKED */.Fay), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES, "Test Series - Section Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.COMPETE */.Z.COMPETE, "Compete - Section Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS, "Enrollments - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS, segment/* SYLLABUS_TAB_CLICKED */.MkJ), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.NOTES */.Z.NOTES, utils/* NOTES_SECTION_CLICKED */.mU), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.SAVED */.Z.SAVED, segment/* SAVE_SAVE_VIEWED */.QIy), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS, segment/* AAD_TAB_CLICKED */.Q2O), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.GET_THE_APP */.Z.GET_THE_APP, "Get Learning App - Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.OTHER_LINKS */.Z.OTHER_LINKS, "Other Links - Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.REPORT_AN_ISSUE */.Z.REPORT_AN_ISSUE, "Report An Issue - Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.BROWSE */.Z.BROWSE, "Browse - Browse Section Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.ENROLLMENTS */.Z.ENROLLMENTS, "Enrollments - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES, "Test - Tests Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS, "Doubts & Solutions - Section Viewed"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.ONE_TO_ONE_LIVE_MENTORSHIP */.Z.ONE_TO_ONE_LIVE_MENTORSHIP, "Live Mentoring - Menu Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.ASK_A_DOUBT */.Z.ASK_A_DOUBT, "Ask a Doubt - Tab Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.VIDEO_LESSONS */.Z.VIDEO_LESSONS, "Video Lessons - Clicked"), (0,_define_property/* default */.Z)(_obj, plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES, events/* UNACADEMY_BOOKS_SECTION_CLICKED */.eE), _obj);
var handleStorageKeyForTestRevamp = function(section, isTestRevampGoal) {
    if (navKeyEventNameMap[section] === navKeyEventNameMap[plusNavBarItems/* default.TEST_SERIES */.Z.TEST_SERIES] && isTestRevampGoal) {
        setStorageKeyForTestRevamp();
    }
};
var sendSegmentEvent = function(section, routeGoalSegmentData, isSyllabusV1Enabled, isGTP) {
    if (navKeyEventNameMap[section] === navKeyEventNameMap[plusNavBarItems/* default.DOUBTS_AND_SOLUTIONS */.Z.DOUBTS_AND_SOLUTIONS]) {
        var isDoubtsAndSolutionVisited = cookies/* default.readCookie */.ZP.readCookie("doubtsAndSolutionVisited", false);
        analytics/* segment.track */.EX.track(navKeyEventNameMap[plusNavBarItems/* default.ASK_A_DOUBT */.Z.ASK_A_DOUBT], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routeGoalSegmentData), {
            dot_type: isDoubtsAndSolutionVisited ? "null" : "blue",
            last_primary_source_section: "Side Navigation Bar"
        }));
        if (!isDoubtsAndSolutionVisited) {
            cookies/* default.setCookie */.ZP.setCookie("doubtsAndSolutionVisited", true, 180);
        }
    }
    if (navKeyEventNameMap[section] === navKeyEventNameMap[plusNavBarItems/* default.NOTES */.Z.NOTES]) {
        var isNotesVisited = cookies/* default.readCookie */.ZP.readCookie("notesVisited", false);
        analytics/* segment.track */.EX.track(navKeyEventNameMap[plusNavBarItems/* default.NOTES */.Z.NOTES], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routeGoalSegmentData), {
            dot_type: isNotesVisited ? "null" : "blue",
            last_primary_source_section: "Side Navigation Bar"
        }));
        if (!isNotesVisited) {
            cookies/* default.setCookie */.ZP.setCookie("notesVisited", true, 100);
        }
    }
    if (navKeyEventNameMap[section] === navKeyEventNameMap[plusNavBarItems/* default.PRINTED_NOTES */.Z.PRINTED_NOTES]) {
        if ((0,utils_localStorage/* localStorageAvailable */.V)()) {
            localStorage.setItem("isPrintedNotesVisited", true);
        }
    }
    var isSyllabusPage = navKeyEventNameMap[section] === navKeyEventNameMap[plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS];
    if (isSyllabusV1Enabled && isSyllabusPage) {
        var isSyllabusVisited = cookies/* default.readCookie */.ZP.readCookie("syllabusVisited", false);
        analytics/* segment.track */.EX.track(navKeyEventNameMap[plusNavBarItems/* default.SYLLABUS */.Z.SYLLABUS], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routeGoalSegmentData), {
            dot_type: isSyllabusVisited ? "null" : "blue",
            last_primary_source_section: "Side Navigation Bar"
        }));
        if (!isSyllabusVisited) {
            cookies/* default.setCookie */.ZP.setCookie("syllabusVisited", true, 180);
        }
        return;
    }
    var eventName = isSyllabusPage && isGTP ? segment/* VIDEO_LESSONS_TAB_CLICKED */.Bf2 : navKeyEventNameMap[section];
    analytics/* segment.track */.EX.track(eventName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, routeGoalSegmentData), {
        last_primary_source_section: "Side Navigation Bar"
    }));
};
var NavItems = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ersq9d31",
    label: "NavItems"
})("position:relative;width:100%;height:100%;");
var PlusNavBarFixed = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ersq9d32",
    label: "PlusNavBarFixed"
})("position:sticky;top:", styleConstants/* Spacings.SPACING_HEADER */.t8.bu, "px;left:0;width:100%;padding:", styleConstants/* Spacings.SPACING_10B */.t8.FC, " ", styleConstants/* Spacings.SPACING_10B */.t8.FC, " 0 0;height:auto;max-height:calc(100vh - ", styleConstants/* Spacings.SPACING_HEADER */.t8.bu + 16, "px);overflow-y:auto;scrollbar-width:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";::-webkit-scrollbar{width:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";background:transparent;}::-webkit-scrollbar-thumb{width:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-radius:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";background:transparent;}&:hover{::-webkit-scrollbar-thumb{background:var(--color-text-secondary);}}");
var PlusNavBar = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,useWindowSize/* default */.Z)(), height = ref.height, width = ref.width;
    var ref1 = (0,react.useState)({
        height: DEFAULT_ITEM_HEIGHT,
        scaleY: 1,
        posY: 0
    }), selectedNavMeta = ref1[0], setSelectedNavMeta = ref1[1];
    var _query = router.query, routerGoalUID = _query.goalUID;
    var selectedGoalUID = (0,useSelectedGoal/* useSelectedGoalUID */.Xm)();
    var goalUID = routerGoalUID || selectedGoalUID;
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var topology = (0,useTopology/* default */.Z)(goalUID).topology;
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var me = (0,useMyInfo/* default */.Z)(auth/* getMe */.jo);
    var hasPlusSubscription = (0,subscription/* getIsSubscribedToPlus */.FZ)(goalUID)(me);
    var isSubscribedToLite = (0,subscription/* getIsSubscribedToLite */.aA)(goalUID)(me);
    var isOfflineSubscription = (0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID)(me);
    var isCatalogueFeatureAvailable = getIsCatalogueFeatureAvailable(topology);
    var isPlusAvailable = getIsPlusAvailable(topology);
    var goalSlug = getTopologySlug(topology);
    var isSyllabusV1Enabled = getIsSyllabusV1Enabled(topology);
    var isRecordedGoal = getIsRecordedGoal(topology);
    var selectedNav = (0,sidenav/* default */.ZP)(selectors_sidenav/* getSelectedNav */.x);
    var routeGoalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: routerGoalUID
    });
    var isTestRevampGoal = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsTestRevampGoal */.ur)(goalUID));
    var showPlatformNav = (0,usePlatformInfo/* default */.Z)().showPlatformNav;
    (0,react.useEffect)(function() {
        var el = document.querySelector('[data-id="'.concat(selectedNav, '"]'));
        var selectedElemHeight = el === null || el === void 0 ? void 0 : el.offsetHeight;
        var posY = (el === null || el === void 0 ? void 0 : el.offsetTop) + styleConstants/* Spacings.SPACING_HEADER_MARGIN */.t8.Cj;
        if (selectedNavMeta.posY === posY && selectedNavMeta.height === selectedElemHeight) {
            return;
        }
        window.posY = posY;
        setSelectedNavMeta({
            height: selectedElemHeight,
            scaleY: selectedElemHeight / DEFAULT_ITEM_HEIGHT,
            posY: posY
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedNav,
        height,
        width,
        isLoggedIn,
        isCatalogueFeatureAvailable,
        isSubscribedToLite
    ]);
    var handleClick = function(nav) {
        return function() {
            (0,sidenav/* setSelectedNav */.Pg)(nav);
            sendSegmentEvent(nav, routeGoalSegmentData, isSyllabusV1Enabled, isGTP);
            handleStorageKeyForTestRevamp(nav, isTestRevampGoal);
        };
    };
    var isSubscribedAndPlusAvailable = hasPlusSubscription && isPlusAvailable;
    var showPlannerItem = (isSubscribedAndPlusAvailable || isOfflineSubscription) && !isGTP && !isRecordedGoal;
    var goalAs = getGoalAs(goalUID, goalSlug);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlusNavBarFixed, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Selected, {
                $isVisible: selectedNavMeta.height,
                $scaleY: selectedNavMeta.scaleY,
                $posY: // window.posY to ensure that due to layout remounts, the entire navbar doesn't remount post page transitions.
                 true ? window.posY || selectedNavMeta.posY : 0
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavItems, {
                children: [
                    (!isLoggedIn || !(hasPlusSubscription || isOfflineSubscription) || !isPlusAvailable) && !showPlatformNav && !isSubscribedToLite && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_Home, {
                        handleClick: handleClick,
                        isSelected: selectedNav === plusNavBarItems/* default.PLUS_HOME */.Z.PLUS_HOME,
                        goalAs: goalAs
                    }),
                    showPlannerItem && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_PlannerItem, {
                        handleClick: handleClick,
                        selectedNav: selectedNav,
                        goalAs: goalAs,
                        isSelected: selectedNav === plusNavBarItems/* default.SCHEDULE */.Z.SCHEDULE
                    }),
                    showPlatformNav && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_PlatformNavItems, {
                        handleClick: handleClick,
                        selectedNav: selectedNav,
                        goalUID: goalUID,
                        goalAs: goalAs
                    }),
                    !showPlatformNav && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_SelfStudy, {
                        handleClick: handleClick,
                        selectedNav: selectedNav,
                        goalUID: goalUID,
                        goalAs: goalAs,
                        hasPlusSubscription: hasPlusSubscription,
                        hasOfflineSubscription: isOfflineSubscription,
                        isCatalogueFeatureAvailable: isCatalogueFeatureAvailable
                    }),
                    !showPlatformNav && (isOfflineSubscription || isSubscribedAndPlusAvailable || isSubscribedToLite) && !isGTP && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_MeSection, {
                        handleClick: handleClick,
                        selectedNav: selectedNav,
                        goalAs: goalAs
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PlusNavBar_PlusNavBar = (PlusNavBar);

;// CONCATENATED MODULE: ./src/layout/index.jsx

/* eslint-disable max-lines */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/prop-types */ 


























var ClassVideoPlayer = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(35303), __webpack_require__.e(82492), __webpack_require__.e(96523), __webpack_require__.e(63953), __webpack_require__.e(42298), __webpack_require__.e(9720), __webpack_require__.e(46571), __webpack_require__.e(16050), __webpack_require__.e(94336), __webpack_require__.e(86181), __webpack_require__.e(20892)]).then(__webpack_require__.bind(__webpack_require__, 86181));
});
var TTUWidgetRenderer = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 7596).then(__webpack_require__.bind(__webpack_require__, 66583));
});
var TTURenderer = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 37921).then(__webpack_require__.bind(__webpack_require__, 37921));
});
var ReferralPopup = (0,Dynamic/* default */.Z)(function() {
    return __webpack_require__.e(/* import() */ 23961).then(__webpack_require__.bind(__webpack_require__, 23961));
});
var layout_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Container/* default */.Z, {
    target: "e1kplr10",
    label: "Container"
})("@media only screen and (max-width:", styleConstants/* breakpoints.tablet */.AV.tablet, "){min-width:0px;}@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){width:100vw;}");
var NavbarWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1kplr11",
    label: "NavbarWrapper"
})("position:relative;grid-column:1/7;z-index:2;height:100%;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){display:none;}");
var EduNavBar = (0,Dynamic/* default */.Z)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(52420), __webpack_require__.e(84872), __webpack_require__.e(868), __webpack_require__.e(30342), __webpack_require__.e(48932)]).then(__webpack_require__.bind(__webpack_require__, 48932));
});
var layout_AppContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(AppContainer/* default */.Z, {
    target: "e1kplr12",
    label: "AppContainer"
})("margin-top:0;@media only screen and (max-width:", styleConstants/* breakpoints.tablet */.AV.tablet, "){width:100%;}@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){display:grid;grid-column-gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";grid-row-gap:0;grid-template-columns:repeat(10,1fr);}");
var layout_Content = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Content/* default */.Z, {
    target: "e1kplr13",
    label: "Content"
})("margin-top:", function(param) {
    var fullHeight = param.fullHeight;
    return fullHeight ? "0" : "40px";
}, ";grid-column:", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : 7;
}, " / 25;grid-template-columns:repeat(\n    ", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 24 : 18;
}, ",32px\n  );", function(param) {
    var position = param.position;
    return position ? "position: ".concat(position, ";") : "";
}, "  @media only screen and (max-width:", styleConstants/* breakpoints.tablet */.AV.tablet, "){margin:auto;width:100%;grid-template-columns:repeat(\n      ", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 24 : 18;
}, ",1fr\n    );}@media only screen and (max-width:728px){grid-template-columns:none;width:100%;}@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 10;grid-row-gap:0;grid-column-gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";display:block;padding:", function(param) {
    var noMobilePadding = param.noMobilePadding;
    return noMobilePadding ? "0px" : "0 ".concat(styleConstants/* Spacings.SPACING_4B */.t8.BM);
}, ";}");
var subscribeUrl = "/goal/[goalSlug]/[goalUID]/subscribe";
var Layout = function(param) {
    var children = param.children, isEducatorSide = param.isEducatorSide, _layoutOptions = param.layoutOptions, layoutOptions = _layoutOptions === void 0 ? {} : _layoutOptions;
    var renderLogin = function renderLogin() {
        if (!isCheckoutUrl && !isLoginRoute) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoginComponent/* default */.Z, {
                loginProps: {
                    setBackButton: setBackButton,
                    backButton: backButton
                },
                drawerProps: {
                    login: true,
                    drawerState: showLoginDrawer,
                    onClose: onClose,
                    showBackButton: backButton.value,
                    hideCloseButton: backButton.value,
                    onPressBack: handleBackPress
                }
            });
        }
    };
    var router = (0,next_router.useRouter)();
    var route = router.route, query = router.query;
    (0,useLoginModalExperiment/* default */.Z)();
    var me = (0,useMyInfo/* default */.Z)(auth/* getMe */.jo);
    var selectedGoal = (0,useSelectedGoal/* default */.ZP)().selectedGoal;
    var ref = (0,toggleables/* useToggleable */.F7)(constants_toggleables/* LOGIN_DRAWER */.es), showLoginDrawer = ref.isOpen, closeLoginDrawer = ref.closeElement;
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    var ttuFlag = (0,stores_ttu/* default */.Z)(ttuSelectors/* getTTUFlag */.YU);
    var showTTUCurtain = (0,stores_ttu/* default */.Z)(ttuSelectors/* getShowTTUCurtain */.qv);
    var ttuShow = (0,stores_ttu/* default */.Z)(ttuSelectors/* getTTUShow */.UX);
    var showReferral = (0,stores_playerReferralDialog/* default */.Z)(playerReferralDialog/* getShowReferralDialog */.E);
    var ref1 = (0,react.useState)(ttuShow), showTTU = ref1[0], setShowTTU = ref1[1];
    var ref2 = (0,react.useState)(false), showTTUTooltip = ref2[0], setShowTTUTooltip = ref2[1];
    var ref3 = (0,react.useState)("Scroll Trigger"), ttuTriggerSource = ref3[0], setTTUTriggerSource = ref3[1];
    var ref4 = (0,react.useState)(showReferral), showReferralDialog = ref4[0], setShowReferralDialog = ref4[1];
    var ref5 = (0,react.useState)({
        value: false,
        fn: function() {}
    }), backButton = ref5[0], setBackButton = ref5[1];
    var handleBackPress = function() {
        backButton.fn();
    };
    /**
   * To check whether it is called from domain other than unacademy
   */ var isExternal = (query === null || query === void 0 ? void 0 : query.external) === "1";
    (0,react.useEffect)(function() {
        setShowReferralDialog(showReferral);
        if (showReferral) {
            analytics/* segment.track */.EX.track(segment/* REFERRAL_PLAYER_POPUP */.ZKS);
        }
    }, [
        showReferral
    ]);
    (0,react.useEffect)(function() {
        setShowTTU(ttuShow);
    }, [
        ttuShow
    ]);
    var _hideIntercom = layoutOptions.hideIntercom, hideIntercom = _hideIntercom === void 0 ? false : _hideIntercom, tmp = layoutOptions.hideSearch, shouldHideSearch = tmp === void 0 ? false : tmp, _isCheckoutUrl = layoutOptions.isCheckoutUrl, isCheckoutUrl = _isCheckoutUrl === void 0 ? false : _isCheckoutUrl, _hideFooter = layoutOptions.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _hideHeader = layoutOptions.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, _showEducatorNav = layoutOptions.showEducatorNav, showEducatorNav = _showEducatorNav === void 0 ? false : _showEducatorNav, _showPlusNav = layoutOptions.showPlusNav, showPlusNav = _showPlusNav === void 0 ? false : _showPlusNav, _fullHeightContent = layoutOptions.fullHeightContent, fullHeightContent = _fullHeightContent === void 0 ? false : _fullHeightContent, _hideGoalSelector = layoutOptions.hideGoalSelector, hideGoalSelector = _hideGoalSelector === void 0 ? false : _hideGoalSelector, _noMobilePadding = layoutOptions.noMobilePadding, noMobilePadding = _noMobilePadding === void 0 ? false : _noMobilePadding, _useLightBaseColor = layoutOptions.useLightBaseColor, useLightBaseColor = _useLightBaseColor === void 0 ? false : _useLightBaseColor, _hidePlayer = layoutOptions.hidePlayer, hidePlayer = _hidePlayer === void 0 ? false : _hidePlayer;
    (0,react.useEffect)(function() {
        if (ttuFlag && !hideIntercom && !me.isEducator && !isMobile) {
            setTimeout(function() {
                return setShowTTUTooltip(true);
            }, 15000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        me.isEducator
    ]);
    var hideSearch = shouldHideSearch || isCheckoutUrl;
    var isLoginRoute = route === "/login";
    var onClose = function() {
        closeLoginDrawer();
    };
    var onCloseTTU = function() {
        setBackButton({
            value: false,
            fn: function() {}
        });
        setShowTTU(false);
        showTTUCurtain(false);
        (0,ttu/* showTTUOption */.U)(query.goalUID || selectedGoal.uid);
    };
    var getBackgroundColor = function() {
        if (constants/* legalPageRoutes.includes */.T3.includes(route)) {
            return "var(--color-base-0)";
        }
        if (useLightBaseColor) {
            return "var(--color-base-1)";
        }
        return null;
    };
    var insideApp = query.inside_app === "true" || false;
    var insideIframeLogin = query.is_iframe_login === "true" || false;
    var backgroundColor = getBackgroundColor();
    var tabletWidth = constants/* tabletRoutes.includes */.VK.includes(route) ? "728px" : "1136px";
    var isTransparent = route === subscribeUrl;
    var isContentFullHeight = fullHeightContent || isTransparent;
    var showClassPlayer = isExternal ? true : !isMobile;
    if (isExternal) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout_Container, {
            backgroundColor: "var(--color-i-black-9)",
            children: [
                children,
                showClassPlayer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassVideoPlayer, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout_Container, {
        backgroundColor: backgroundColor,
        children: [
            !insideApp && !insideIframeLogin && !hideHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                hideSearch: hideSearch,
                hideGoalSelector: hideGoalSelector,
                isCheckoutUrl: isCheckoutUrl,
                transparent: isTransparent,
                isLoginUrl: isLoginRoute
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout_AppContainer, {
                backgroundColor: backgroundColor,
                transparentHeader: isTransparent,
                $tabletWidth: tabletWidth,
                $isFooterHidden: hideFooter,
                children: [
                    (showPlusNav || showEducatorNav) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarWrapper, {
                        children: [
                            showPlusNav && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusNavBar_PlusNavBar, {}),
                            showEducatorNav && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EduNavBar, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(layout_Content, {
                        fullHeight: isContentFullHeight,
                        fullWidth: !showPlusNav && !showEducatorNav,
                        noMobilePadding: noMobilePadding,
                        position: route.indexOf("/educator/drive/folder/[itemUID]") !== -1 ? "relative" : "",
                        children: children
                    }),
                    !hidePlayer && showClassPlayer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassVideoPlayer, {})
                ]
            }),
            !insideApp && !insideIframeLogin && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseFooter/* default */.Z, {
                display: !hideFooter && !showPlusNav && !isEducatorSide,
                noFooter: hideFooter
            }),
            renderLogin(),
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TTURenderer, {
                onCloseTTU: onCloseTTU,
                showTTU: showTTU,
                backButton: backButton,
                setBackButton: setBackButton,
                handleBackPress: handleBackPress,
                ttuTriggerSource: ttuTriggerSource
            }),
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TTUWidgetRenderer, {
                showTTU: showTTU,
                setShowTTU: setShowTTU,
                showTTUTooltip: showTTUTooltip,
                setShowTTUTooltip: setShowTTUTooltip,
                ttuTriggerSource: ttuTriggerSource,
                setTTUTriggerSource: setTTUTriggerSource,
                hideIntercom: hideIntercom
            }),
            showReferralDialog ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReferralPopup, {
                setShowReferralDialog: setShowReferralDialog
            }) : null
        ]
    });
};
/* harmony default export */ var layout = (Layout);


/***/ }),

/***/ 41721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export playerReferralDialogStore */
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59148);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77090);




var getLocalStorageItem = function(key) {
    if ((0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageAvailable */ .V)()) {
        return localStorage.getItem(key);
    }
};
var playerReferralDialogStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(set) {
    return {
        showReferralDialog: false,
        setShowReferralDialog: function(classUID) {
            return set(function() {
                var showDialog = !(0,_utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* .readCookie */ .vQ)("referral-player") || Math.round((new Date() - new Date(Number((0,_utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* .readCookie */ .vQ)("referral-player")))) / (1000 * 3600 * 24)) > 7;
                return {
                    showReferralDialog: classUID ? getLocalStorageItem("liveSessions[".concat(classUID.current, "]")) > 1800 && showDialog : null
                };
            });
        }
    };
});
var usePlayerReferralDialogStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(playerReferralDialogStore);
/* harmony default export */ __webpack_exports__["Z"] = (usePlayerReferralDialogStore);


/***/ }),

/***/ 76205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getShowReferralDialog; },
/* harmony export */   "z": function() { return /* binding */ getSetShowReferralDialog; }
/* harmony export */ });
var getShowReferralDialog = function(param) {
    var showReferralDialog = param.showReferralDialog;
    return showReferralDialog;
};
var getSetShowReferralDialog = function(param) {
    var setShowReferralDialog = param.setShowReferralDialog;
    return setShowReferralDialog;
};


/***/ }),

/***/ 53373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);



var mergeTwoSortedArray = function() {
    var array11 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], array22 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var newArray = [];
    var index1 = 0;
    var index2 = 0;
    var length1 = array11.length;
    var length2 = array22.length;
    var array1 = array11.map(function(item, index) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            index: index
        });
    });
    var array2 = array22.map(function(item, index) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            index: index
        });
    });
    while(index1 <= length1 - 1 || index2 <= length2 - 1)if (array1.length === index1 || array2.length === index2) {
        if (array1.length === index1) {
            var _newArray;
            (_newArray = newArray).push.apply(_newArray, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(array2.slice(index2)));
            index2 = length2;
        } else {
            var _newArray1;
            (_newArray1 = newArray).push.apply(_newArray1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(array1.slice(index1)));
            index1 = length1;
        }
    } else if (array1[index1].rank <= array2[index2].rank) {
        newArray.push(array1[index1]);
        index1 += 1;
    } else {
        newArray.push(array2[index2]);
        index2 += 1;
    }
    return newArray;
};
var moveArrayElement = function(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        // eslint-disable-next-line no-plusplus
        while(k--){
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};
var algos = {
    mergeTwoSortedArray: mergeTwoSortedArray,
    moveArrayElement: moveArrayElement
};
/* harmony default export */ __webpack_exports__["Z"] = (algos);


/***/ })

}]);